<template>
    <div
        class="form-order container"
        :class="{
            'bg-white':isHasProductItems,
            'p-4' : isStandalone,
            'p-3 backend' : !isStandalone
        }"
    >
        <googleRecaptcha v-if="isStandalone" ref="googleRecaptcha" @scriptLoaded="googleScriptLoaded" />
        <div v-if="isMissingRequest && isStandalone" class="container bg-white p-5 text-center">
            <div class="h4 mb-0 text-black">{{ labelCaption }}</div>
            <div class="text-danger lh-1-2">
                We regret to inform you that product orders cannot be accepted at the moment.
            </div>
            <div>
                <img :src="'/assets/dta/img/booking-order.jpg'" alt="booking order" class="img-fluid" style="width:400px">
            </div>
            <div>
                <a href="/tours" class="btn btn_1">View Other Products</a>
            </div>
        </div>
        <div v-else-if="errorMessage && !isStandalone" class="container bg-white text-center">
            <div class="text-danger lh-1-2">{{ errorMessage }}</div>
            <div>
                <img :src="'/assets/dta/img/booking-order.jpg'" alt="booking order" class="img-fluid" style="width:400px">
            </div>
        </div>
        <div v-if="isHasProductItems" class="row" :class="{'gx-4' : isStandalone, 'gx-3' : !isStandalone}">
            <div class="col-lg-12 col-xl-8">
                <template v-if="isStandalone">
                    <div class="title-label mb-3">
                        <div class="h4 mb-0 text-black">{{ labelCaption }}</div>
                        <div>Fill in your details and review your booking.</div>
                    </div>
                    <div v-if="(!loggedIn || !isCustomer) && isHasGetAuthUser" class="card login-register shadow-sm border rounded mb-4">
                        <div class="card-body d-flex justify-content-start align-content-center">
                            <div>
                                <span class="ti ti-login-2"></span>
                            </div>
                            <div>
                                <div>Log in or register for a seamless booking and more benefits!</div>
                                <div><a href="/app/login">Log In</a> or <a href="/app/register">Register</a></div>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="contact-detail">
                    <div class="h5 text-black" :class="{'mb-1' : !isStandalone}">Contact Details (for E-voucher)</div>
                    <div class="card shadow-sm border rounded" :class="{'mb-4' : isStandalone, 'mb-3' : !isStandalone}">
                        <div class="card-body px-4 py-3 card-body-ckfrt">
                            <p v-if="isStandalone" class="mb-3">Please fill in all fields correctly to ensure you receive the booking confirmation voucher in your email.</p>
                            <div
                                class="row"
                                :class="{
                                    'gy-3' : isStandalone,
                                    'gy-2' : !isStandalone
                                }"
                            >
                                <selectUserInput
                                    v-if="!isStandalone"
                                    v-model="attributes.profile_id"
                                    name="profile_id"
                                    label="Customer"
                                    class="col-12"
                                    :dd-auto-refresh="true"
                                    :options="attributes.profileOptions || []"
                                    :endpoint="$gpApp.baseSpaAppUrl('/customer/profile')"
                                    @selectOption="profileSelectOption($event)"
                                    @clearOption="profileClearOption"
                                />
                                <textInput
                                    v-model.trim="attributes.name"
                                    label="Full Name (as in Passport/Official ID Card)"
                                    class="col-12 col-md-6"
                                    name="name"
                                    placeholder="Enter full name"
                                    :max-length="255"
                                    :required="!isCustomer"
                                    :disabled="isCustomer"
                                />
                                <textInput
                                    v-model.trim="attributes.nationality"
                                    label="Nationality"
                                    class="col-12 col-md-6"
                                    name="nationality"
                                    placeholder="Enter nationality"
                                    :max-length="255"
                                    :required="true"
                                />
                                <emailInput
                                    v-model.trim="attributes.email"
                                    label="Email Address"
                                    class="col-12 col-md-6"
                                    name="email"
                                    placeholder="Enter email address"
                                    :max-length="255"
                                    :required="!isCustomer"
                                    :disabled="isCustomer"
                                />
                                <div class="col-12 col-md-6">
                                    <phoneInput
                                        v-model.trim="attributes.phone"
                                        label="Phone or WhatApp Number"
                                        name="phone"
                                        placeholder="821-9820-7281"
                                        :max-length="50"
                                        :prefix="true"
                                        :prefix-options="attributes.phoneOptions"
                                        :prefix-endpoint="phoneEndpoint"
                                        :prefix-open-endpoint="phoneOpenEndpoint"
                                        :required="true"
                                    />
                                </div>
                                <template v-if="(productItems || {}).cs">
                                    <div :class="{
                                            'py-3': !isStandalone
                                        }"
                                    >
                                        <div class="mb-1"><strong class="text-black">Billing Address</strong></div>
                                        <p class="mb-0">This address will be used for payment verification and official billing purposes. Please choose one of our supported travel agents near your location.</p>
                                    </div>
                                    <textInput
                                        v-model.trim="attributes.billing_address"
                                        label="Address Information"
                                        class="col-12"
                                        name="billing_address"
                                        placeholder="Enter street name and other relevant information"
                                        :required="true"
                                    />
                                    <selectInput
                                        ref="selectBillingCity"
                                        v-model.trim="attributes.billing_city"
                                        label="City"
                                        class="col-12 col-md-6"
                                        name="billing_city"
                                        :endpoint="(loggedIn || !isStandalone) ? $gpApp.baseSpaAppUrl('/region/city') : null"
                                        :open-endpoint="(!loggedIn && isStandalone) ? '/region/city' : null"
                                        :option-addons="['state_name', 'country_name']"
                                        :simple="true"
                                        :required="true"
                                        :dd-auto-refresh="true"
                                        :options="(attributes.billingCityOptions||[])"
                                        @selectOption="onBillingAddressSelectCity"
                                        @clearOption="onBillingAddressClearOption"
                                    />
                                    <selectInput
                                        ref="selectBillingState"
                                        v-model.trim="attributes.billing_state"
                                        label="State or Province"
                                        class="col-12 col-md-6"
                                        name="billing_state"
                                        :endpoint="(loggedIn || !isStandalone) ? $gpApp.baseSpaAppUrl('/region/state') : null"
                                        :open-endpoint="(!loggedIn && isStandalone) ? '/region/state' : null"
                                        :option-addons="['country_name']"
                                        :simple="true"
                                        :dd-auto-refresh="true"
                                        :options="(attributes.billingStateOptions||[])"
                                        @selectOption="onBillingAddressSelectState"
                                        @clearOption="onBillingAddressClearOption"
                                    />
                                    <selectInput
                                        ref="selectBillingCountry"
                                        v-model.trim="attributes.billing_country"
                                        label="Country"
                                        class="col-12 col-md-6"
                                        name="billing_country"
                                        :endpoint="(loggedIn || !isStandalone) ? $gpApp.baseSpaAppUrl('/region/country') : null"
                                        :open-endpoint="(!loggedIn && isStandalone) ? '/region/country' : null"
                                        :dd-auto-refresh="true"
                                        :required="true"
                                        :options="(attributes.billingCountryOptions||[])"
                                        @selectOption="onBillingAddressSelectCountry"
                                        @clearOption="onBillingAddressClearOption"
                                    />
                                    <textInput
                                        v-model.trim="attributes.billing_zipcode"
                                        label="Post Code"
                                        class="col-12 col-md-6"
                                        name="billing_zipcode"
                                        placeholder="Enter post code"
                                        :min="0"
                                        :step="1"
                                        :max-length="50"
                                    />
                                </template>
                                <radioInput
                                    v-model.trim="attributes.booking_for"
                                    class="col-12"
                                    name="booking_for"
                                    :options="[
                                        { label: (isStandalone?'I am the guest':'As guest'), value: '0' },
                                        { label: (isStandalone?'I\'m booking for another person':'For another person'), value: '1' }
                                    ]"
                                    :required="true"
                                />
                                <template v-if="isBookingForOther">
                                    <textInput
                                        v-model.trim="attributes.op_name"
                                        label="Guest Name (as in Passport/Official ID Card)"
                                        class="col-12 col-md-6"
                                        name="op_name"
                                        placeholder="Enter guest name"
                                        :max-length="255"
                                        :required="isBookingForOther"
                                    />
                                    <textInput
                                        v-model.trim="attributes.op_nationality"
                                        label="Nationality"
                                        class="col-12 col-md-6"
                                        name="op_nationality"
                                        placeholder="Enter nationality"
                                        :max-length="255"
                                        :required="isBookingForOther"
                                    />
                                    <emailInput
                                        v-model.trim="attributes.op_email"
                                        label="Email Address"
                                        class="col-12 col-md-6"
                                        name="op_email"
                                        placeholder="Enter email address"
                                        :max-length="255"
                                        :required="isBookingForOther"
                                    />
                                    <phoneInput
                                        v-model.trim="attributes.op_phone"
                                        label="Phone or WhatApp Number"
                                        class="col-12 col-md-6"
                                        name="op_phone"
                                        placeholder="821-9820-7281"
                                        :max-length="50"
                                        :prefix="true"
                                        :prefix-options="attributes.op_phoneOptions"
                                        :prefix-endpoint="phoneEndpoint"
                                        :prefix-open-endpoint="phoneOpenEndpoint"
                                        :required="isBookingForOther"
                                    />
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="(productItems || {}).cs" class="mb-4">
                        <div class="h5 text-black" :class="{'mb-1' : !isStandalone}">ARRIVAL DAY PICK UP & DROP OFF POINT</div>
                        <textAreaInput
                            v-model.trim="attributes.departure_detail"
                            label="Please type your pick up location address or flight details if you’re coming from airport with your date, time, and airport location. Also tell us where you want to be dropped off afterwards. This helps us pick you up on time on the first day."
                            class="col-12"
                            name="departure_detail"
                            placeholder="Eg: PICK UP: GA716 ETA 1300 17 MAR FROM MELBOURNE TULLAMARINE AIRPORT. DROP OFF: GRAND HYATT MELBOURNE (123 COLLINS ST, MELBOURNE)."
                        />
                    </div>
                </div>
                <template v-if="Array.isArray(productItems.product) && productItems.product.length>0 && attributes.departure_date" >
                    <div class="product-item" :class="{'mb-4' : isStandalone, 'mb-3' : !isStandalone}">
                        <div class="h5 text-black" :class="{'mb-1' : !isStandalone}">{{ labelPriceType }}</div>
                        <div class="item-box">
                            <template v-if="isHasRoom" >
                                <div class="item-room">
                                    <div class="pax-label">{{ productItems.product[0].name }}</div>
                                    <div class="pax-note">
                                        <small v-if="productItems.product[0].note" ><span class="ti ti-vocabulary"></span> {{ productItems.product[0].note }}</small>
                                        <small v-if="roomCapacity"><span class="ti ti-users"></span> {{ roomCapacity }}</small>
                                        <small v-if="productItems.product[0].room"><span class="ti ti-door"></span> {{ productItems.product[0].room }}</small>
                                        <small v-if="productItems.product[0].bed"><span class="ti ti-bed-flat"></span> {{ productItems.product[0].bed }}</small>
                                    </div>
                                    <hr>
                                    <div
                                        class="pax-prices"
                                        v-for="(item, itemIndex) in (productItems.product || [])"
                                    >
                                        <div class="d-flex align-items-center">
                                            <div class="flex-grow-1">
                                                <div class="pax-label">{{ (getQuantity(item, true)>1 ? getQuantity(item) + ' ' : '') +  getLabelPriceType(item) }}</div>
                                                <div class="pax-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                            </div>
                                            <div class="flex-shrink-0" v-html="getPrice(item)"></div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template
                                v-else
                                v-for="(item, itemIndex) in (productItems.product || [])"
                            >
                                <div class="d-flex align-items-center item-pax">
                                    <div class="flex-shrink-0">
                                        <template v-if="showInputQtyType(item)==='selectInput'">
                                            <selectInput
                                                v-model="item.book_request"
                                                placeholder="Qty"
                                                :name="item.id"
                                                :options="item.bkrqOptions || []"
                                                :required="itemIndex===0"
                                                @update:modelValue="updateModelValue($event, item)"
                                            />
                                        </template>
                                        <template v-else>
                                            <numberInput
                                                v-model="item.book_request"
                                                :name="item.id"
                                                placeholder="Qty"
                                                :min="1"
                                                :required="itemIndex===0"
                                                @update:modelValue="updateModelValue($event, item)"
                                            />
                                        </template>
                                    </div>
                                    <div class="flex-grow-1 d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <div class="pax-label">{{ getLabelPriceType(item) }}</div>
                                            <div class="pax-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                            <div v-if="productItems.tpl==='vehicle' && addonServiceInfo(item)" class="pax-service-info" v-html="addonServiceInfo(item)"></div>
                                        </div>
                                        <div class="flex-shrink-0" v-html="getPrice(item)"></div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div
                        v-if="isHasManifest"
                        class="travel-manifest" :class="{'mb-4' : isStandalone, 'mb-3' : !isStandalone}"
                    >
                        <div class="h5 text-black" :class="{'mb-1' : !isStandalone}">Travel Manifest</div>
                        <div
                            class="accordion"
                            :class="{ 'rooming': isHasRoom }"
                        >
                            <template v-if="isHasRoom">
                                <template
                                    v-if="(productItems.product || []).length"
                                    v-for="(bqValue, bqIndex) in Array.from({length: productItems.product[0].book_request || 0}, (_, index) => index + 1)"
                                    :key="`room-${bqIndex}`"
                                >
                                    <div class="accordion-item">
                                        <div class="accordion-header d-flex align-items-center">
                                            <div class="accordion-btn-icon">
                                                <button
                                                    type="button"
                                                    v-if="bqIndex===0"
                                                    class="btn btn-success text-nowrap btn-add-room"
                                                    :class="{
                                                        'btn-sm' : !isStandalone
                                                    }"
                                                    @click="addRoom"
                                                >
                                                    <span class="ti ti-circle-plus" :class="{'fs-1rem':!isStandalone}" ></span> Add Room
                                                </button>
                                                <button
                                                    v-else
                                                    type="button"
                                                    class="btn text-nowrap btn-remove-room"
                                                    :class="{
                                                        'btn-warning' : isStandalone,
                                                        'btn-sm btn-danger' : !isStandalone
                                                    }"
                                                    @click="removeRoom"
                                                >
                                                    <span class="ti ti-trash-x" :class="{'fs-1rem':!isStandalone}"></span> Remove
                                                </button>
                                            </div>
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse" :data-bs-target="`#room-${bqIndex}`" aria-expanded="true" :aria-controls="`room-${bqIndex}`">
                                                Room #{{ bqIndex+1 }}
                                            </button>
                                        </div>
                                        <div :id="`room-${bqIndex}`" class="accordion-collapse collapse show">
                                            <div class="accordion-body p-0">
                                                <div class="accordion bedding">
                                                    <template v-for="(item, itemIndex) in (productItems.product || [])">
                                                        <template
                                                            v-if="productItems.manifest && productItems.manifest.hasOwnProperty(item.id)"
                                                            v-for="(manifest, manifestIndex) in (productItems.manifest[item.id].guests[bqIndex] || [])"
                                                        >
                                                            <div
                                                                v-if="manifest"
                                                                class="accordion-item"
                                                            >
                                                                <div class="accordion-header">
                                                                    <div class="accordion-button" type="button" :data-bs-target="`#manifest-${bqIndex}-${manifestIndex}`" aria-expanded="true" :aria-controls="`manifest-${bqIndex}-${manifestIndex}`">
                                                                        Guest {{ getLabelPriceType(item) }}
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    :id="`manifest-${bqIndex}-${manifestIndex}`"
                                                                    :data-manifest-id="manifest.id"
                                                                    class="accordion-collapse collapse show"
                                                                >
                                                                    <div class="accordion-body">
                                                                        <buildCustomFrom
                                                                            :key="`manifest-${bqIndex}-${manifestIndex}-${item.id}`"
                                                                            :unique-key="`manifest-${bqIndex}-${manifestIndex}-${item.id}`"
                                                                            :attributes="manifest"
                                                                            :elements="getCustomForm(productItems.manifest[item.id].customForm)"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template
                                v-else
                                v-for="(item, itemIndex) in (productItems.product || [])"
                            >
                                <template v-if="productItems.manifest && productItems.manifest.hasOwnProperty(item.id)">
                                    <template
                                        v-for="(manifest, manifestIndex) in (productItems.manifest[item.id].guests || [])"
                                    >
                                        <div
                                            v-if="manifest"
                                            class="accordion-item"
                                        >
                                            <h2 class="accordion-header">
                                                <button class="accordion-button" type="button" data-bs-toggle="collapse" :data-bs-target="`#manifest-${manifest.id}`" aria-expanded="true" :aria-controls="`manifest-${manifest.id}`">
                                                    #{{ manifestIndex+1 }} - {{ isSeaterProduct(item) ? 'Guest' : ('Guest ' + getLabelPriceType(item)) }}
                                                </button>
                                            </h2>
                                            <div
                                                :id="`manifest-${manifest.id}`"
                                                :data-manifest-id="manifest.id"
                                                class="accordion-collapse collapse show"
                                            >
                                                <div class="accordion-body">
                                                    <buildCustomFrom
                                                        :key="`manifest-${manifest.id}-${item.id}`"
                                                        :unique-key="`manifest-${manifest.id}-${item.id}`"
                                                        :attributes="manifest"
                                                        :elements="getCustomForm(productItems.manifest[item.id].customForm)"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </div>
                    </div>
                    <div class="product-addons">
                        <div
                            v-if="Array.isArray(productItems.pickup) && productItems.pickup.length>0"
                            class="accordion pickup" :class="{'mb-4' : isStandalone, 'mb-3' : !isStandalone}"
                        >
                            <div class="accordion-item">
                                <div
                                    class="accordion-header"
                                    :class="{
                                        'd-flex align-items-center': locationIsSelected(productItems.pickup)
                                    }"
                                >
                                    <div v-if="locationIsSelected(productItems.pickup)" class="accordion-btn-icon">
                                        <button
                                            type="button"
                                            class="btn text-nowrap btn-remove-room"
                                            :class="{
                                                'btn-warning' : isStandalone,
                                                'btn-sm btn-danger' : !isStandalone
                                            }"
                                            @click="removeLocationSelected(productItems.pickup)"
                                        >
                                            <span class="ti ti-trash-x" :class="{'fs-1rem':!isStandalone}"></span> Remove
                                        </button>
                                    </div>
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#pickup-location" aria-expanded="true" aria-controls="pickup-location">
                                        {{ (isPointToPointTicket || isReturnDifferentDPTP) ? 'Pickup & Drop Off Location' : 'Pickup Location' }}
                                    </button>
                                </div>
                                <div id="pickup-location" class="accordion-collapse collapse show">
                                    <div class="accordion-body p-0">
                                        <ul class="list-group">
                                            <li
                                                v-for="(item, index) in productItems.pickup"
                                                :key="`pickup-${index}`"
                                                class="list-group-item d-flex align-items-start"
                                            >
                                                <div class="flex-shrink-0">
                                                    <div class="form-check">
                                                        <input
                                                            v-model="item.checked"
                                                            class="form-check-input"
                                                            type="radio"
                                                            :name="`pickup-${item.id}`"
                                                            :id="`radioPickup${index}`"
                                                            :value="item.id"
                                                            :required="!locationIsSelected(productItems.pickup)"
                                                            @change="updateLocationSelected(item, productItems.pickup)"
                                                        >
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 px-3">
                                                    <div class="accor-title">{{ item.name }}</div>
                                                    <div class="accor-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                                    <div class="accor-service-info" v-html="locationServiceInfo(item)" ></div>
                                                    <div v-if="getNotePriceType(item, 'notes')" class="accor-description">
                                                        <hr class="my-2">
                                                        <div class="ql-editor lh-1-1 px-0 pt-0">
                                                            {{ getNotePriceType(item, 'notes') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex-shrink-0" v-html="getPrice(item)"></div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="Array.isArray(productItems.dropOff) && productItems.dropOff.length>0"
                            class="accordion dropoff" :class="{'mb-4' : isStandalone, 'mb-3' : !isStandalone}"
                        >
                            <div class="accordion-item">
                                <div
                                    class="accordion-header"
                                    :class="{
                                        'd-flex align-items-center': locationIsSelected(productItems.dropOff)
                                    }"
                                >
                                    <div v-if="locationIsSelected(productItems.dropOff)" class="accordion-btn-icon">
                                        <button
                                            type="button"
                                            class="btn text-nowrap btn-remove-room"
                                            :class="{
                                                'btn-warning' : isStandalone,
                                                'btn-sm btn-danger' : !isStandalone
                                            }"
                                            @click="removeLocationSelected(productItems.dropOff)"
                                        >
                                            <span class="ti ti-trash-x" :class="{'fs-1rem':!isStandalone}"></span> Remove
                                        </button>
                                    </div>
                                    <div class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#dropoff-location" aria-expanded="true" aria-controls="dropoff-location">
                                        Drop Off Location
                                    </div>
                                </div>
                                <div id="dropoff-location" class="accordion-collapse collapse show">
                                    <div class="accordion-body p-0">
                                        <ul class="list-group">
                                            <li
                                                v-for="(item, index) in productItems.dropOff"
                                                :key="`pickup-${index}`"
                                                class="list-group-item d-flex align-items-start"
                                            >
                                                <div class="flex-shrink-0">
                                                    <div class="form-check">
                                                        <input
                                                            v-model="item.checked"
                                                            class="form-check-input"
                                                            type="radio"
                                                            :name="`dropOff-${item.id}`"
                                                            :id="`radioDropOff${index}`"
                                                            :value="item.id"
                                                            :required="!locationIsSelected(productItems.dropOff)"
                                                            @change="updateLocationSelected(item, productItems.dropOff)"
                                                        >
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 px-3">
                                                    <div class="accor-title">{{ item.name }}</div>
                                                    <div class="accor-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                                    <div class="accor-service-info" v-html="locationServiceInfo(item)" ></div>
                                                    <div v-if="getNotePriceType(item, 'notes')" class="accor-description">
                                                        <hr class="my-2">
                                                        <div class="ql-editor lh-1-1 px-0 pt-0">
                                                            {{ getNotePriceType(item, 'notes') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex-shrink-0" v-html="getPrice(item)"></div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-if="Array.isArray(productItems.addons) && productItems.addons.length>0">
                            <div class="accordion addons" :class="{'mb-4' : isStandalone, 'mb-2' : !isStandalone}">
                                <div class="accordion-item border-bottom-0">
                                    <div class="accordion-header">
                                        <div class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#accor-addons" aria-expanded="true" aria-controls="accor-addons">
                                            Add Ons
                                        </div>
                                    </div>
                                    <div id="accor-addons" class="accordion-collapse collapse show">
                                        <div class="accordion-body">
                                            <div class="addon-items">
                                                <template v-for="(addon, addonIndex) in productItems.addons">
                                                    <template v-if="addon.label">
                                                        <div class="accordion addon-item mb-2">
                                                            <div class="accordion-item">
                                                                <div class="accordion-header">
                                                                    <div class="accordion-button" type="button" data-bs-toggle="collapse" :data-bs-target="`#accor-addon-item-${addonIndex}`" aria-expanded="true" :aria-controls="`accor-addon-item-${addonIndex}`">
                                                                        {{ addon.label }}
                                                                    </div>
                                                                </div>
                                                                <div :id="`accor-addon-item-${addonIndex}`" class="accordion-collapse collapse show">
                                                                    <div class="accordion-body">
                                                                        <template v-for="(list, listIndex) in (addon.list || [])">
                                                                            <template v-if="(list.data || []).length > 0">
                                                                                <div v-if="list.text" class="ql-editor lh-1-1 px-0 pt-0" v-html="list.text"></div>
                                                                                <ul class="list-group mb-2">
                                                                                    <template v-if="list.addon_key=== 'Guests'">
                                                                                        <template v-for="(items, itemsIndex) in list.data">
                                                                                            <li class="list-group-item">
                                                                                                <div class="list-group-title">{{ items[0].name }}</div>
                                                                                                <div
                                                                                                    v-if="items[0].note"
                                                                                                    class="list-group-note"
                                                                                                >
                                                                                                    <small>{{ items[0].note }}</small>
                                                                                                </div>
                                                                                                <div
                                                                                                    v-if="items[0].notes"
                                                                                                    class="list-group-notes ql-editor lh-1-1 px-0 py-0 mt-2"
                                                                                                    v-html="items[0].notes"
                                                                                                ></div>
                                                                                            </li>
                                                                                            <li class="list-group-item py-3">
                                                                                                <template v-for="(item, itemIndex) in items">
                                                                                                    <div class="d-flex align-items-center item-pax">
                                                                                                        <div class="flex-shrink-0">
                                                                                                            <template v-if="showInputQtyType(item)==='selectInput'">
                                                                                                                <selectInput
                                                                                                                    v-model="item.book_request"
                                                                                                                    placeholder="Qty"
                                                                                                                    :name="item.id"
                                                                                                                    :options="item.bkrqOptions || []"
                                                                                                                    @update:modelValue="onAddonGroupQtyChange($event, item, items)"
                                                                                                                />
                                                                                                            </template>
                                                                                                            <template v-else>
                                                                                                                <numberInput
                                                                                                                    v-model="item.book_request"
                                                                                                                    :name="item.id"
                                                                                                                    placeholder="Qty"
                                                                                                                    @update:modelValue="onAddonGroupQtyChange($event, item, items)"
                                                                                                                />
                                                                                                            </template>
                                                                                                        </div>
                                                                                                        <div class="flex-grow-1 d-flex align-items-center">
                                                                                                            <div class="flex-grow-1 px-3">
                                                                                                                <div class="pax-label">{{ (getQuantity(item, true)>1 ? getQuantity(item) + ' ' : '') + getLabelPriceType(item) }}</div>
                                                                                                                <div class="pax-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                                                                                            </div>
                                                                                                            <div class="flex-shrink-0" v-html="getPrice(item)"></div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <hr v-if="itemIndex < (items.length-1)" class="my-2">
                                                                                                </template>
                                                                                                <div v-if="isGroupRequireDepartureDate(items)" class="mt-3 pt-2 border-top">
                                                                                                    <div class="row align-items-center">
                                                                                                        <div class="col-12">
                                                                                                            <selectInput
                                                                                                                v-model="items[0].departure_date"
                                                                                                                label="Tour Departure Date"
                                                                                                                placeholder="Select departure date"
                                                                                                                :options="addonDepartureDateOptions"
                                                                                                                :clearable="false"
                                                                                                                :disabled="!isAddonGroupSelected(items)"
                                                                                                                :required="isAddonGroupSelected(items)"
                                                                                                                @update:modelValue="onAddonGroupDepartureDateChange($event, items)"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </li>
                                                                                        </template>
                                                                                    </template>
                                                                                    <li
                                                                                        v-else
                                                                                        class="list-group-item"
                                                                                    >
                                                                                        <template v-for="(items, itemsIndex) in list.data">
                                                                                            <template v-for="(item, itemIndex) in items">
                                                                                                <div
                                                                                                    class="flex-grow-1 d-flex item-pax"
                                                                                                    :class="{
                                                                                                        'align-items-start' : items[0].notes,
                                                                                                        'align-items-center' : !items[0].notes
                                                                                                    }"
                                                                                                >
                                                                                                    <div class="flex-shrink-0">
                                                                                                        <template v-if="showInputQtyType(item)==='selectInput'">
                                                                                                            <selectInput
                                                                                                                v-model="item.book_request"
                                                                                                                placeholder="Qty"
                                                                                                                :name="item.id"
                                                                                                                :options="item.bkrqOptions || []"
                                                                                                                @update:modelValue="onAddonSingleQtyChange($event, item)"
                                                                                                            />
                                                                                                        </template>
                                                                                                        <template v-else>
                                                                                                            <numberInput
                                                                                                                v-model="item.book_request"
                                                                                                                :name="item.id"
                                                                                                                placeholder="Qty"
                                                                                                                @update:modelValue="onAddonSingleQtyChange($event, item)"
                                                                                                            />
                                                                                                        </template>
                                                                                                    </div>
                                                                                                    <div
                                                                                                        class="flex-grow-1 d-flex"
                                                                                                        :class="{
                                                                                                            'align-items-start' : items[0].notes,
                                                                                                            'align-items-center' : !items[0].notes
                                                                                                        }"
                                                                                                    >
                                                                                                        <div class="flex-grow-1 px-3">
                                                                                                            <div class="pax-label">{{ getLabelPriceType(item) }}</div>
                                                                                                            <div class="pax-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                                                                                            <div class="pax-service-info" v-html="addonServiceInfo(item)"></div>
                                                                                                            <div v-if="items[0].notes" class="pax-notes">
                                                                                                                <hr class="my-2">
                                                                                                                <div class="ql-editor lh-1-1 px-0 py-0" v-html="items[0].notes"></div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div class="flex-shrink-0" v-html="getPrice(item, (list.addon_key === 'Vehicles'?'Unit':'Service'))"></div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div v-if="isRequireDepartureDate(item)" class="mt-2 mb-3">
                                                                                                    <div class="row align-items-center">
                                                                                                        <div class="col-12">
                                                                                                            <selectInput
                                                                                                                v-model="item.departure_date"
                                                                                                                label="Tour Departure Date"
                                                                                                                placeholder="Select departure date"
                                                                                                                :options="addonDepartureDateOptions"
                                                                                                                :clearable="false"
                                                                                                                :disabled="!isAddonItemSelected(item)"
                                                                                                                :required="isAddonItemSelected(item)"
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </template>
                                                                                        </template>
                                                                                    </li>
                                                                                </ul>
                                                                            </template>
                                                                        </template>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template
                                                        v-else
                                                        v-for="(list, listIndex) in (addon.list || [])"
                                                    >
                                                        <template v-if="(list.data || []).length > 0">
                                                            <div v-if="list.text" class="ql-editor lh-1-1 px-0 pt-0" v-html="list.text"></div>
                                                            <ul class="list-group mb-2">
                                                                <template v-if="list.addon_key=== 'Guests'">
                                                                    <template v-for="(items, itemsIndex) in list.data">
                                                                        <li class="list-group-item">
                                                                            <div class="list-group-title">{{ items[0].name }}</div>
                                                                            <div
                                                                                v-if="items[0].note"
                                                                                class="list-group-note"
                                                                            >
                                                                                <small>{{ items[0].note }}</small>
                                                                            </div>
                                                                            <div
                                                                                v-if="items[0].notes"
                                                                                class="list-group-notes ql-editor lh-1-1 px-0 py-0 mt-2"
                                                                                v-html="items[0].notes"
                                                                            ></div>
                                                                        </li>
                                                                        <li class="list-group-item py-3">
                                                                            <template v-for="(item, itemIndex) in items">
                                                                                <div class="d-flex align-items-center item-pax">
                                                                                    <div class="flex-shrink-0">
                                                                                        <template v-if="showInputQtyType(item)==='selectInput'">
                                                                                            <selectInput
                                                                                                v-model="item.book_request"
                                                                                                placeholder="Qty"
                                                                                                :name="item.id"
                                                                                                :options="item.bkrqOptions || []"
                                                                                                @update:modelValue="onAddonGroupQtyChange($event, item, items)"
                                                                                            />
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <numberInput
                                                                                                v-model="item.book_request"
                                                                                                :name="item.id"
                                                                                                placeholder="Qty"
                                                                                                @update:modelValue="onAddonGroupQtyChange($event, item, items)"
                                                                                            />
                                                                                        </template>
                                                                                    </div>
                                                                                    <div class="flex-grow-1 d-flex align-items-center">
                                                                                        <div class="flex-grow-1 px-3">
                                                                                            <div class="pax-label">{{ (getQuantity(item, true)>1 ? getQuantity(item) + ' ' : '') + getLabelPriceType(item) }}</div>
                                                                                            <div class="pax-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                                                                        </div>
                                                                                        <div class="flex-shrink-0" v-html="getPrice(item)"></div>
                                                                                    </div>
                                                                                </div>
                                                                                <hr v-if="itemIndex < (items.length-1)" class="my-2">
                                                                            </template>
                                                                            <div v-if="isGroupRequireDepartureDate(items)" class="mt-3 pt-2 border-top">
                                                                                <div class="row align-items-center">
                                                                                    <div class="col-12">
                                                                                        <selectInput
                                                                                            v-model="items[0].departure_date"
                                                                                            label="Tour Departure Date"
                                                                                            placeholder="Select departure date"
                                                                                            :options="addonDepartureDateOptions"
                                                                                            :clearable="false"
                                                                                            :disabled="!isAddonGroupSelected(items)"
                                                                                            :required="isAddonGroupSelected(items)"
                                                                                            @update:modelValue="onAddonGroupDepartureDateChange($event, items)"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    </template>
                                                                </template>
                                                                <li
                                                                    v-else
                                                                    class="list-group-item"
                                                                >
                                                                    <template v-for="(items, itemsIndex) in list.data">
                                                                        <template v-for="(item, itemIndex) in items">
                                                                            <div
                                                                                class="flex-grow-1 d-flex item-pax"
                                                                                :class="{
                                                                                    'align-items-start' : items[0].notes,
                                                                                    'align-items-center' : !items[0].notes
                                                                                }"
                                                                            >
                                                                                <div class="flex-shrink-0">
                                                                                    <template v-if="showInputQtyType(item)==='selectInput'">
                                                                                        <selectInput
                                                                                            v-model="item.book_request"
                                                                                            placeholder="Qty"
                                                                                            :name="item.id"
                                                                                            :options="item.bkrqOptions || []"
                                                                                            @update:modelValue="onAddonSingleQtyChange($event, item)"
                                                                                        />
                                                                                    </template>
                                                                                    <template v-else>
                                                                                        <numberInput
                                                                                            v-model="item.book_request"
                                                                                            :name="item.id"
                                                                                            placeholder="Qty"
                                                                                            @update:modelValue="onAddonSingleQtyChange($event, item)"
                                                                                        />
                                                                                    </template>
                                                                                </div>
                                                                                <div
                                                                                    class="flex-grow-1 d-flex"
                                                                                    :class="{
                                                                                        'align-items-start' : items[0].notes,
                                                                                        'align-items-center' : !items[0].notes
                                                                                    }"
                                                                                >
                                                                                    <div class="flex-grow-1 px-3">
                                                                                        <div class="pax-label">{{ getLabelPriceType(item) }}</div>
                                                                                        <div class="pax-note"><small>{{ getNotePriceType(item, 'note') }}</small></div>
                                                                                        <div class="pax-service-info" v-html="addonServiceInfo(item)"></div>
                                                                                        <div v-if="items[0].notes" class="pax-notes">
                                                                                            <hr class="my-2">
                                                                                            <div class="ql-editor lh-1-1 px-0 py-0" v-html="items[0].notes"></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="flex-shrink-0" v-html="getPrice(item, (list.addon_key === 'Vehicles'?'Unit':'Service'))"></div>
                                                                                </div>
                                                                            </div>
                                                                            <div v-if="isRequireDepartureDate(item)" class="mt-2 mb-3">
                                                                                <div class="row align-items-center">
                                                                                    <div class="col-12">
                                                                                        <selectInput
                                                                                            v-model="item.departure_date"
                                                                                            label="Tour Departure Date"
                                                                                            placeholder="Select departure date"
                                                                                            :options="addonDepartureDateOptions"
                                                                                            :clearable="false"
                                                                                            :disabled="!isAddonItemSelected(item)"
                                                                                            :required="isAddonItemSelected(item)"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </template>
                                                                </li>
                                                            </ul>
                                                        </template>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
            <aside class="col-lg-12 col-xl-4" id="sidebar">
                <div class="card shadow-sm border rounded mb-4 booking-detail">
                    <div class="card-header">
                        <div class="card-title mb-0 h6 text-black">
                            Booking Details
                        </div>
                    </div>
                    <div class="card-body card-body-ckscnd">
                        <div class="mb-3">
                            <div class="product fw-semibold">{{ productName }}</div>
                            <div v-for="destination in destinations" class="destination lh-1"><small>{{ destination }}</small></div>
                        </div>
                        <div class="row gy-2">
                            <dateInput
                                v-model.trim="attributes.departure_date"
                                :label="isReturnTicket ? 'Travel return date' : 'Travel departure date'"
                                class="col-12"
                                name="date"
                                placeholder="Choose date..."
                                class-calendar="departure-date"
                                :required="true"
                                :is-today-highlight="false"
                                :min-date="minDate"
                                :max-date="maxDate"
                                :disable-dates="disableDates"
                                :disable-range-dates="disableRangeDates"
                                @update:modelValue="updateDepartureDate"
                                @beforeEnter="beforeDepartureDate"
                                @afterEnter="openDepartureDate"
                                @changeMonth="changeMonthDepartureDate"
                                @beforeLeave="closeDepartureDate"
                            />
                            <dateInput
                                v-if="isReturnDifferentDay || isReturnDifferentDPTP"
                                v-model.trim="attributes.return_date"
                                label="Travel return date"
                                class="col-12"
                                name="return_date"
                                placeholder="Choose date..."
                                class-calendar="return-date"
                                :required="true"
                                :is-today-highlight="false"
                                :min-date="minDateReturn"
                                :max-date="maxDate"
                                :disable-dates="disableDates"
                                :disable-range-dates="disableRangeDates"
                                :clearable="!!attributes.departure_date"
                                :disabled="!attributes.departure_date"
                            />
                        </div>
                        <div
                            v-if="(productItems.product || []).find(item => item.book_request>0) && attributes.departure_date"
                            class="mt-3"
                        >
                            <div
                                v-if="isHasRoom"
                                class="lh-1 mb-3"
                            >
                                <div>{{ productItems.product[0].name + (productItems.product[0].book_request >=2 ? ` (${productItems.product[0].book_request} rooms)` : '') }}</div>
                                <div class="rooming-note">
                                    <small v-if="productItems.product[0].note" ><span class="ti ti-vocabulary"></span> {{ productItems.product[0].note }}</small>
                                    <small v-if="roomCapacity"><span class="ti ti-users"></span> {{ roomCapacity }}</small>
                                    <small v-if="productItems.product[0].room"><span class="ti ti-door"></span> {{ productItems.product[0].room }}</small>
                                    <small v-if="productItems.product[0].bed"><span class="ti ti-bed-flat"></span> {{ productItems.product[0].bed }}</small>
                                </div>
                            </div>
                            <div
                                v-else-if="isGrouping(productItems.product[0]) && !isSeaterProduct(productItems.product[0])"
                                class="lh-1 mb-3"
                            >
                                <div>{{ productItems.product[0].name }}</div>
                                <div v-if="productItems.product[0].note"><small class="text-muted">{{ productItems.product[0].note }}</small></div>
                            </div>
                            <template v-for="(item, itemIndex) in (productItems.product || [])">
                                <div
                                    v-if="calculateQty(item)>0"
                                    class="d-flex justify-content-between align-items-center booking-items"
                                >
                                    <div class="pe-2">
                                        <div>{{ calculateQty(item) }} {{ isSeaterProduct(item) ? getLabelPriceType(item) : (getLabelPriceType(item) + (item.book_request>=2?'s':'')) }}</div>
                                        <div v-if="productItems.tpl === 'vehicle' && getNotePriceType(item, 'note')" style="line-height: 1">
                                            <small class="text-muted">{{ getNotePriceType(item, 'note') }}</small>
                                        </div>
                                    </div>
                                    <div>{{ calculatePax(item) }}</div>
                                </div>
                            </template>
                            <hr v-if="locationIsSelected(productItems.pickup) || locationIsSelected(productItems.dropOff)" >
                            <div
                                v-if="locationIsSelected(productItems.pickup)"
                                class="d-flex justify-content-between align-items-center booking-items mt-1"
                            >
                                <div class="lh-1 pe-1">
                                    <div class="text-muted"><small>Pickup Location</small></div>
                                    <div v-if="(isReturnDifferentDay || isDepartureTicket || isReturnDifferentDPTP) && isHasReturnPickup">
                                        <i>{{ locationIsSelected(productItems.pickup, false).name }}</i>
                                        <span class="px-1 text-primary"><i>to</i></span>
                                        <i>{{ productItems.return_pickup.name }}</i>
                                    </div>
                                    <div v-else>{{ locationIsSelected(productItems.pickup, false).name }}</div>
                                </div>
                                <div>{{ calculatePax(locationIsSelected(productItems.pickup, false), false, 1) }}</div>
                            </div>
                            <div
                                v-if="locationIsSelected(productItems.pickup) && (isPointToPointTicket || isReturnDifferentDPTP)"
                                class="d-flex justify-content-between align-items-center booking-items mt-1"
                            >
                                <div class="pt-1 lh-1 pe-1">
                                    <div class="text-muted"><small>Drop Off Location</small></div>
                                    <div v-if="isReturnDifferentDPTP && isHasReturnPickup">
                                        <i>{{ productItems.return_pickup.name }}</i>
                                        <span class="px-1 text-primary"><i>to</i></span>
                                        <i>{{ locationIsSelected(productItems.pickup, false).name }}</i>
                                    </div>
                                    <div v-else>{{ locationIsSelected(productItems.pickup, false).name }}</div>
                                </div>
                                <div>{{ calculatePax(locationIsSelected(productItems.pickup, false), false, 1) }}</div>
                            </div>
                            <div
                                v-if="locationIsSelected(productItems.dropOff)"
                                class="d-flex justify-content-between align-items-center booking-items mt-1"
                            >
                                <div class="pt-1 lh-1 pe-1">
                                    <div class="text-muted"><small>Drop Off Location</small></div>
                                    <div v-if="(isReturnDifferentDay || isReturnTicket) && isHasReturnPickup">
                                        <i>{{ productItems.return_pickup.name }}</i>
                                        <span class="px-1 text-primary"><i>to</i></span>
                                        <i>{{ locationIsSelected(productItems.dropOff, false).name }}</i>
                                    </div>
                                    <div v-else>{{ locationIsSelected(productItems.dropOff, false).name }}</div>
                                </div>
                                <div>{{ calculatePax(locationIsSelected(productItems.dropOff, false), false, 1) }}</div>
                            </div>
                            <template v-if="addonFilterSelections.length>0">
                                <hr>
                                <div class="mb-2"><i>Add Ons</i></div>
                                <template v-for="(item, itemIndex) in addonFilterSelections">
                                    <template v-if="item.hasOwnProperty('_labelGroup')">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>{{ item._labelGroup }}</div>
                                            <div v-if="item.departure_date" class="badge bg-light text-dark border">
                                                <i class="ti ti-calendar-event me-1"></i>{{ formatAddonDate(item.departure_date) }}
                                            </div>
                                        </div>
                                        <div
                                            v-for="(subItem, subItemIndex) in item.items"
                                            class="d-flex justify-content-between align-items-center booking-items"
                                        >
                                            <div class="px-2 text-muted"><span class="ti ti-point"></span>{{ calculateQty(subItem, true) }} {{ getLabelPriceType(subItem) + (subItem.book_request>=2?'s':'') }}</div>
                                            <div>{{ calculatePax(subItem, false, 0, true) }}</div>
                                        </div>
                                    </template>
                                    <div
                                        v-else
                                        class="d-flex justify-content-between align-items-center booking-items"
                                    >
                                        <div class="pe-2">
                                            <div>{{ calculateQty(item, true) }} {{ getLabelPriceType(item) + (item.book_request>=2?'s':'') }}</div>
                                            <div v-if="item.departure_date" class="text-muted small">
                                                <i class="ti ti-calendar-event me-1"></i>{{ formatAddonDate(item.departure_date) }}
                                            </div>
                                        </div>
                                        <div>{{ calculatePax(item, false, 0, true) }}</div>
                                    </div>
                                </template>
                            </template>
                            <hr>
                            <div class="d-flex justify-content-between align-items-center">
                                <div>Total Amount</div>
                                <div>{{ calculateSubtotal() }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button
                            v-if="attributes.departure_date"
                            type="button"
                            class="btn btn-primary w-100 btn-continue btn_1 full-width"
                            :disabled="!(productItems.product || []).find(item => item.book_request>0)"
                            @click="continueOrder($event)"
                        >
                            {{ productItems.confirm_id ? 'Save Change' : 'Continue' }}
                        </button>
                        <button
                            v-if="productItems.confirm_id && !isStaffEditBO"
                            type="button"
                            class="btn btn-primary w-100 btn-continue btn_1 full-width"
                            style="margin-top: 0.1rem;"
                            @click="previewBooking"
                        >
                            Preview Booking
                        </button>
                        <button
                            v-if="productItems.scart_id && !isStaffEditBO"
                            type="button"
                            class="btn btn-primary w-100 btn-continue btn_1 full-width"
                            style="margin-top: 0.1rem;"
                            @click="shoppingCart"
                        >
                            View Shopping Cart
                        </button>
                    </div>
                </div>
            </aside>
        </div>
    </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import './css/form-order.scss';
import {toolbox} from "../../../../components/toolbox/toolbox.js";
import {elementHelper} from "../../../../utils/helpers/elementHelper.js";
import ApiService from "../../../../services/api.js";
import AjxService from "../../../../services/ajax.js";
import {errorHelper} from "../../../../utils/helpers/errorHelper.js";
import {utilHelper} from "../../../../utils/helpers/utilHelper.js";
import googleRecaptcha from "../../../../components/form/googleRecaptcha.vue";
import {objectHelper} from "../../../../utils/helpers/objectHelper.js";
import {dateHelper} from "../../../../utils/helpers/dateHelper.js";
import {formatHelper} from "../../../../utils/helpers/formatHelper.js";
import moment from "moment";
import buildCustomFrom from "../../../admin/views/custom-field/build/forms/buildCustomFrom.vue";
import {formHelper} from "../../../../utils/helpers/formHelper.js";
import {cloneDeep} from "lodash";
import {cusfieldHelper} from "../../../../utils/helpers/cusfieldHelper.js";
import {gid, setgeo} from "../../../../utils/webRequest.js";
import selectUserInput from "../../../../components/form/selectUserInput.vue";
import {sweetAlertHelper} from "../../../../utils/helpers/sweetAlertHelper.js";
import selectTravelAgent from "../../../../components/form/selectTravelAgent.vue";

export default {
    name: "formOrder",
    components: {
        selectUserInput,
        buildCustomFrom,
        googleRecaptcha,
        selectTravelAgent,
        textInput : toolbox.textInput,
        selectInput : toolbox.selectInput,
        emailInput : toolbox.emailInput,
        phoneInput : toolbox.phoneInput,
        radioInput : toolbox.radioInput,
        dateInput : toolbox.dateInput,
        numberInput : toolbox.numberInput,
        textAreaInput : toolbox.textAreaInput
    },
    emits:[
        'viewBooking',
        'goShoppingCart'
    ],
    props: {
        isStandalone: {
            type: Boolean,
            default: false
        },
        labelCaption: {
            type: String,
            default: 'Booking'
        },
        productId: {
            type: [null, String],
            default: null
        },
        productName: {
            type: [null, String],
            default: null
        },
        destinations: {
            type: Array,
            default: []
        },
        priceType: {
            type: [null, String],
            default: null
        },
        departureDate: {
            type: [null, String],
            default: null
        },
        confirmId: {
            type: [null, String],
            default: null
        },
        profile: {
            type: [null, Object],
            default: null
        },
        switchOrderId: {
            type: [null, String],
            default: null
        },
        initialQty: {
            type: [null, Number, String],
            default: null
        }
    },
    data() {
        return {
            isMounted: false,
            isMissingRequest: false,
            errorMessage: null,
            isHasGetAuthUser: false,
            isGoogleScriptLoaded: false,
            attributes: {},
            productItems: {},
            disableDates: [],
            disableRangeDates: [],
            minDate: null,
            maxDate: null,
            loaderDateInput: null,
            showLocalAgent: false
        }
    },
    computed: {
        loggedIn() {
            return this.$store.getters["auth/loggedIn"];
        },
        isCustomer() {
            return this.$store.getters["auth/isCustomer"];
        },
        isPersonalCustomer() {
            return this.$store.getters["auth/isPersonalCustomer"];
        },
        isCompanyCustomer() {
            return this.$store.getters["auth/isCompanyCustomer"];
        },
        phoneOpenEndpoint() {
            if(this.isStandalone) {
                if(this.loggedIn) {
                    return null;
                }
                return '/region/country/phone';
            }
            return null;
        },
        phoneEndpoint() {
            if(this.isStandalone) {
                if(this.loggedIn) {
                    return '/region/country/phone';
                }
            }
            return null;
        },
        roomCapacity() {
            let capacity = '';
            if(this.isHasRoom) {
                let match = this.productItems.product.find(item => item.guest.toLowerCase().trim() === 'adult');
                if(match) {
                    capacity = (isNaN(parseInt(match.adult_qty)) ? '1' : match.adult_qty) + 'A';
                    match = this.productItems.product.find(item => item.guest.toLowerCase().trim() === 'child');
                    if(match) {
                        capacity = capacity + (isNaN(parseInt(match.child_qty)) ? '1' : match.child_qty) + 'C';
                    }
                }
            }
            return capacity;
        },
        isHasRoom() {
            if(!objectHelper.isEmptyObject(this.productItems)) {
                if(this.productItems.hasOwnProperty('product') && Array.isArray(this.productItems.product) && this.productItems.product.length > 0) {
                    return this.productItems.product[0].hasOwnProperty('room');
                }
            }
            return false;
        },
        isHasManifest() {
            if(!objectHelper.isEmptyObject(this.productItems)) {
                if(this.productItems.hasOwnProperty('product') && Array.isArray(this.productItems.product) && this.productItems.product.length > 0) {
                    return this.productItems.product.find(item => item.book_request>0) && this.productItems.tpl !== 'vehicle' && !objectHelper.isEmptyObject(this.productItems.manifest);
                }
            }
            return false;
        },
        labelPriceType() {
            if(this.isHasRoom) {
                return 'Room Detail'
            }

            if(this.productItems.tpl==='vehicle') {
                return 'Vehicle Service'
            }

            return 'Travel Guests'
        },
        addonFilterSelections() {
            const _addons = [];
            if(this.productItems.hasOwnProperty('addons') && Array.isArray(this.productItems.addons) && this.productItems.addons.length > 0) {
                this.productItems.addons.forEach(addon => {
                    (addon.list || []).forEach(list => {
                        if((list.data || []).length>0) {
                            (list.data || []).forEach(items => {
                                if((items || []).length>0) {
                                    const _filteredItems = items.filter(item => this.calculateQty(item, true)>0);
                                    if(_filteredItems.length>0) {
                                        if(list.addon_key=== 'Guests') {
                                            _addons.push({
                                                _labelGroup: _filteredItems[0].name,
                                                departure_date: items[0].departure_date || _filteredItems[0].departure_date || null,
                                                items: _filteredItems
                                            });
                                        } else {
                                            _filteredItems.forEach(item => {
                                                _addons.push(item);
                                            })
                                        }
                                    }
                                }
                            });
                        }
                    })
                });
            }
            return _addons;
        },
        addonDepartureDateOptions() {
            if (!this.attributes.departure_date) {
                return [];
            }
            const options = [];
            const start = moment(this.attributes.departure_date);
            const total = this.totalDay;
            for (let i = 0; i < total; i++) {
                const mDate = moment(start).add(i, 'days');
                const val = mDate.format('YYYY-MM-DD');
                const dayName = mDate.format('dddd, DD MMM YYYY');
                options.push({
                    id: val,
                    name: total > 1 ? `${dayName} (Day ${i + 1})` : dayName
                });
            }
            return options;
        },
        isBookingForOther() {
            const _value = parseInt(this.attributes.booking_for);
            return !isNaN(_value) && _value >= 1;
        },
        isHasProductItems() {
            return !objectHelper.isEmptyObject(this.productItems);
        },
        totalDay() {
            const _tday = parseInt(this.productItems?.tday);
            return isNaN(_tday) || _tday <= 0 ? 1 : _tday;
        },
        isReturnDifferentDay() {
            if (this.productItems && Array.isArray(this.productItems.product)) {
                return this.productItems.product.some(item => (item.ticket_type || '') === 'Return on a Different Day');
            }
            return false;
        },
        isReturnDifferentDPTP() {
            if (this.productItems && Array.isArray(this.productItems.product)) {
                return this.productItems.product.some(item => (item.ticket_type || '') === 'Return on a Different DPTP');
            }
            return false;
        },
        isDepartureTicket() {
            if (this.productItems && Array.isArray(this.productItems.product)) {
                return this.productItems.product.some(item => (item.ticket_type || '') === 'One Way Departure');
            }
            return false;
        },
        isReturnTicket() {
            if (this.productItems && Array.isArray(this.productItems.product)) {
                return this.productItems.product.some(item => (item.ticket_type || '') === 'One Way Return');
            }
            return false;
        },
        isPointToPointTicket() {
            if (this.productItems && Array.isArray(this.productItems.product)) {
                return this.productItems.product.some(item => (item.ticket_type || '') === 'Point To Point');
            }
            return false;
        },
        isHasReturnPickup() {
            return this.productItems && this.productItems.return_pickup;
        },
        minDateReturn() {
            if (this.attributes.departure_date && this.totalDay) {
                return dateHelper.dateParse(this.attributes.departure_date).add(-1, 'days').format('YYYY-MM-DD');
            }
            return null;
        },
        isStaffEditBO() {
            return this.productItems && this.productItems.staff_editbo;
        }
    },
    watch:{
        minDateReturn(newValue) {
            if (newValue && this.attributes.return_date) {
                if (this.attributes.return_date < newValue) {
                    this.attributes.return_date = newValue;
                }
            }
        },
        'attributes.departure_date'() {
            this.attributes.return_date = null;
            this.resetAddonDepartureDates();
        },
        'attributes.booking_for'() {
            this.attributes.op_name = null;
            this.attributes.op_nationality = null;
            this.attributes.op_email = null;
            this.attributes.op_phone = null;
            this.autoFillFirstManifest();
        },
        'attributes.name'() {
            if (!this.isBookingForOther) {
                this.autoFillFirstManifest();
            }
        },
        'attributes.nationality'() {
            if (!this.isBookingForOther) {
                this.autoFillFirstManifest();
            }
        },
        'attributes.phone'() {
            if (!this.isBookingForOther) {
                this.autoFillFirstManifest();
            }
        },
        'attributes.op_name'() {
            if (this.isBookingForOther) {
                this.autoFillFirstManifest();
            }
        },
        'attributes.op_nationality'() {
            if (this.isBookingForOther) {
                this.autoFillFirstManifest();
            }
        },
        'attributes.op_phone'() {
            if (this.isBookingForOther) {
                this.autoFillFirstManifest();
            }
        },
        profile(newValue) {
            if(!this.isStandalone) {
                if(!objectHelper.isEmptyObject(newValue) && newValue?.id) {
                    this.attributes.profile_id = newValue.id;
                    this.attributes.profileOptions = [{...newValue}];
                } else {
                    this.attributes.profile_id = null;
                    this.attributes.profileOptions = [];
                }
            }
        }
    },
    mounted() {
        this.isMounted = true;
        this.$nextTick(() => {
            this.setActivated();
            this.isMounted = false;
        });
    },
    updated() {
        this.initTooltips();
    },
    beforeUnmount() {
        if (window.bootstrap && window.bootstrap.Tooltip) {
            const tooltipTriggerList = [].slice.call(this.$el.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                const tooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                if (tooltip) {
                    tooltip.dispose();
                }
            });
        }
    },
    unmounted() {
        this.setDeactivated();
    },
    activated() {
        if(!this.isMounted) {
            this.setActivated();
        }
    },
    deactivated() {
        this.setDeactivated();
    },
    methods: {
        showWhy() {
            sweetAlertHelper.alert(
                'Free Service',
                "<div class='lh-1-2'>Having a local agent representative is a bonus for you. That means you have a real person to call in your timezone who can handle complex add-ons like flights and visas that you can't always do online.</div>",
                'info'
            );
        },
        initTooltips() {
            this.$nextTick(() => {
                if (window.bootstrap && window.bootstrap.Tooltip) {
                    const tooltipTriggerList = [].slice.call(this.$el.querySelectorAll('[data-bs-toggle="tooltip"]'));
                    tooltipTriggerList.map(function (tooltipTriggerEl) {
                        if (!window.bootstrap.Tooltip.getInstance(tooltipTriggerEl)) {
                            new window.bootstrap.Tooltip(tooltipTriggerEl);
                        }
                    });
                }
            });
        },
        setActivated() {
            this.errorMessage = null;
            this.isHasGetAuthUser = false;
            this.disableDates = [];
            this.disableRangeDates = [];
            this.minDate = null;
            this.maxDate = null;
            this.loaderDateInput = null;
            this.productItems = {};

            this.attributes = {
                productId: this.productId,
                price_type: this.priceType,
                departure_date: this.departureDate,
                return_date: null,
                name: null,
                nationality: null,
                email: null,
                phone: null,
                phoneOptions: [],
                booking_for: '0',
                op_name: null,
                op_nationality: null,
                op_email: null,
                op_phone: null,
                op_phoneOptions: [],
                billing_address: null,
                billing_city: null,
                billing_state: null,
                billing_country: null,
                billing_zipcode: null
            }

            this.attributes.profile_id = null;
            this.attributes.profileOptions = [];
            if(!this.isStandalone && !objectHelper.isEmptyObject(this.profile) && this.profile?.id) {
                this.attributes.profile_id = this.profile.id;
                this.attributes.profileOptions = [{...this.profile}];
            }

            if (this.isGoogleScriptLoaded || !this.isStandalone) {
                this.googleScriptLoaded();
            }
        },
        setDeactivated() {
            this.disableDates = [];
            this.loaderDateInput = null;
            this.errorMessage = null;
        },
        async googleScriptLoaded() {
            if (this.isStandalone) {
                let geo = await gid();
                if (!geo) {
                    try {
                        const geoData = await setgeo();
                        geo = geoData.i;
                    } catch (error) {
                        this.isMissingRequest = true;
                    }
                }

                if(geo) {
                    const isGuest = window.localStorage.getItem("guest") === "isGuest";
                    if(!isGuest) {
                        await this.$store.dispatch("auth/getAuthUser").then(response => {
                            if(this.isCustomer) {
                                this.attributes.name = response.name;
                                this.attributes.email = response.email;
                                this.attributes.nationality = response?.profile?.nationality || null;
                                if(response?.profile?.phone1 && response?.profile?.phone1prefix) {
                                    this.attributes.phone = [response.profile.phone1prefix, response.profile.phone1];
                                } else if(response?.profile?.phone2 && response?.profile?.phone2prefix) {
                                    this.attributes.phone = [response.profile.phone2prefix, response.profile.phone2];
                                }

                                if(response.primary_address) {
                                    this.attributes.billing_address = response.primary_address?.address;
                                    this.attributes.billing_city = response.primary_address?.data.city_id;
                                    this.attributes.billing_state = response.primary_address?.data.state_id;
                                    this.attributes.billing_country = response.primary_address?.data.country_id;
                                    this.attributes.billing_zipcode = response.primary_address?.postcode;
                                }
                            }
                        }).finally(() => {
                            this.isHasGetAuthUser = true;
                            this.updateDepartureDate(this.attributes.departure_date);
                        });
                    } else {
                        this.isHasGetAuthUser = true;
                        await this.updateDepartureDate(this.attributes.departure_date);
                    }
                } else {
                    this.isMissingRequest = true;
                }
            } else {
                this.isHasGetAuthUser = true;
                await this.updateDepartureDate(this.attributes.departure_date);
            }
        },
        setDisableRangeDates(strDate = null) {
            if (strDate && dateHelper.isDate(strDate)) {
                this.disableRangeDates = [
                    [
                        dateHelper.dateParse(dateHelper.firstDayOfMonth(strDate)).format('YYYY-MM-DD'),
                        dateHelper.dateParse(dateHelper.lastDayOfMonth(strDate)).format('YYYY-MM-DD')
                    ]
                ];
            } else {
                this.disableRangeDates = [
                    [
                        dateHelper.dateParse(dateHelper.firstDayOfMonth(new Date())).format('YYYY-MM-DD'),
                        dateHelper.dateParse(dateHelper.lastDayOfMonth(new Date())).format('YYYY-MM-DD')
                    ]
                ];
            }
        },
        beforeDepartureDate(event) {
            this.minDate = null;
            this.maxDate = null;
            this.disableDates = [];
            this.setDisableRangeDates(`${event.year.toString()}-${event.month}-01`);
        },
        changeMonthDepartureDate(event, isDropdown = true) {
            this.minDate = null;
            this.maxDate = null;
            this.disableDates = [];
            this.setDisableRangeDates(`${event.year.toString()}-${event.month}-01`);
            this.openDepartureDate(event, isDropdown);
        },
        async openDepartureDate(event, isDropdown = true) {
            if (!this.loaderDateInput && this.attributes.productId && this.attributes.price_type && (!isDropdown || (isDropdown && event.dropdown))) {
                const endpoint = `/booking/${this.attributes.productId}/${this.attributes.price_type}/availability`;
                const payload = {
                    date: `${event.year.toString()}-${event.month}-01`
                }

                if (isDropdown) {
                    this.loaderDateInput = event.toolboxId;
                    elementHelper.loader.show(this.loaderDateInput, event.dropdown, 36, 36, 'dots');
                } else {
                    this.loaderDateInput = utilHelper.getUuid4();
                }

                this.abortController = ApiService.getAbortController();
                if (this.loggedIn) {
                    if(!this.isStandalone) {
                        payload.staff = true;
                    }
                    ApiService.post(endpoint, payload, this.abortController).then(response => {
                        if(!objectHelper.isEmptyObject(response.data)) {
                            this.disableRangeDates = [];
                            if(response.data.hasOwnProperty('minDate')) {
                                this.minDate = response.data.minDate;
                            } else {
                                this.minDate = null;
                            }

                            if(response.data.hasOwnProperty('maxDate')) {
                                this.maxDate = response.data.maxDate;
                            } else {
                                this.maxDate = null;
                            }

                            if(response.data.hasOwnProperty('disableDates')) {
                                this.disableDates = Array.isArray(response.data.disableDates) ? response.data.disableDates : Object.values(response.data.disableDates);
                            } else {
                                this.disableDates = [];
                            }
                        }
                    }).catch(error => {
                        if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                            errorHelper.error(error);
                        }
                    }).finally(() => {
                        if (this.loaderDateInput) {
                            if (isDropdown) {
                                elementHelper.loader.hide(this.loaderDateInput);
                            }
                            this.abortController = null;
                            this.loaderDateInput = null;
                        }
                    });
                } else {
                    await this.$refs.googleRecaptcha.verify().then(async token => {
                        payload.token = token;
                        AjxService.post(endpoint, payload, this.abortController).then(response => {
                            if(!objectHelper.isEmptyObject(response.data)) {
                                this.disableRangeDates = [];
                                if(response.data.hasOwnProperty('minDate')) {
                                    this.minDate = response.data.minDate;
                                } else {
                                    this.minDate = null;
                                }

                                if(response.data.hasOwnProperty('maxDate')) {
                                    this.maxDate = response.data.maxDate;
                                } else {
                                    this.maxDate = null;
                                }

                                if(response.data.hasOwnProperty('disableDates')) {
                                    this.disableDates = Array.isArray(response.data.disableDates) ? response.data.disableDates : Object.values(response.data.disableDates);
                                } else {
                                    this.disableDates = [];
                                }
                            }
                        }).catch(error => {
                            if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                                errorHelper.error(error);
                            }
                        }).finally(() => {
                            if (this.loaderDateInput) {
                                if (isDropdown) {
                                    elementHelper.loader.hide(this.loaderDateInput);
                                }
                                this.abortController = null;
                                this.loaderDateInput = null;
                            }
                        });
                    }).catch(error => {
                        if (this.loaderDateInput) {
                            if (isDropdown) {
                                elementHelper.loader.hide(this.loaderDateInput);
                            }
                            this.abortController = null;
                            this.loaderDateInput = null;
                        }
                    });
                }
            }
        },
        closeDepartureDate(event) {
            if (this.loaderDateInput === event.toolboxId) {
                if (this.abortController) {
                    this.abortController.abort();
                }
                elementHelper.loader.hide(this.loaderDateInput);
                this.abortController = null;
                this.loaderDateInput = null;
            }
        },
        async updateDepartureDate(value) {
            if (value && this.attributes.productId && this.attributes.price_type) {
                let loaderId = null;
                let endpoint = `/booking/${this.attributes.productId}/${this.attributes.price_type}/items`;
                const bookItems = this.getBookingItems();
                const payload = {
                    date: value
                }

                if(this.switchOrderId) {
                    payload.switchOrderId = this.switchOrderId;
                }

                if(!objectHelper.isEmptyObject(bookItems)) {
                    payload.bookItems = bookItems;
                }

                if(this.confirmId && (objectHelper.isEmptyObject(this.productItems) || this.isStaffEditBO)) {
                    endpoint += `/${this.confirmId}`;
                }

                if (this.loggedIn) {
                    if(!this.isStandalone) {
                        payload.staff = true;
                        if(objectHelper.isEmptyObject(this.productItems)) {
                            loaderId = utilHelper.getUniqueId();
                            elementHelper.loader.show(loaderId, this.$el.closest('.modal-body'), 36, 36, 'dots');
                        }

                        if(!this.attributes.billing_address && this.attributes.profile_id) {
                            payload.profile_id = this.attributes.profile_id
                            payload.billing_address = true
                        }
                    } else if(!this.attributes.billing_address) {
                        payload.billing_address = true
                    }

                    if (this.switchOrderId) {
                        payload.billing_address = true;
                    }

                    ApiService.post(endpoint, payload).then(response => {
                        if(!objectHelper.isEmptyObject(response.data)) {
                            if(response.data.hasOwnProperty('attributes')) {
                                if(!objectHelper.isEmptyObject(response.data.attributes)) {
                                    Object.entries(response.data.attributes).forEach(([key, value]) => {
                                        if(!['ccs_support_option', 'ccs_country_name', 'ccs_city_name', 'billing_country_name', 'billing_state_name', 'billing_city_name'].includes(key)) {
                                            if(key==='billing_city') {
                                                this.attributes['billingCityOptions'] = [
                                                    {
                                                        id: value,
                                                        name: response.data.attributes.billing_city_name || '',
                                                        state_id: response.data.attributes.billing_state || null,
                                                        country_id: response.data.attributes.billing_country || null
                                                    }
                                                ];
                                            } else if(key==='billing_state') {
                                                this.attributes['billingStateOptions'] = [
                                                    {
                                                        id: value,
                                                        name: response.data.attributes.billing_state_name || '',
                                                        country_id: response.data.attributes.billing_country || null
                                                    }
                                                ];
                                            } else if(key==='billing_country') {
                                                this.attributes['billingCountryOptions'] = [
                                                    {
                                                        id: value,
                                                        name: response.data.attributes.billing_country_name || ''
                                                    }
                                                ];
                                            }

                                            this.attributes[key] = value;
                                        }
                                    })
                                }
                                delete response.data.attributes;
                            }

                            if(response.data.hasOwnProperty('billing_address')) {
                                if(!objectHelper.isEmptyObject(response.data.billing_address)) {
                                    const billing_address = response.data.billing_address;

                                    this.attributes.billingCityOptions = [
                                        {
                                            id: billing_address.city_id,
                                            name: billing_address.city,
                                            state_id: billing_address.state_id,
                                            country_id: billing_address.country_id
                                        }
                                    ];

                                    this.attributes.billingStateOptions = [
                                        {
                                            id: billing_address.state_id,
                                            name: billing_address.state,
                                            country_id: billing_address.country_id
                                        }
                                    ];

                                    this.attributes.billingCountryOptions = [
                                        {
                                            id: billing_address.country_id,
                                            name: billing_address.country
                                        }
                                    ];

                                    this.attributes.billing_address = billing_address.address;
                                    this.attributes.billing_city = billing_address.city_id;
                                    this.attributes.billing_state = billing_address.state_id;
                                    this.attributes.billing_country = billing_address.country_id;
                                    this.attributes.billing_zipcode = billing_address.zipcode;
                                }
                                delete response.data.billing_address;
                            }

                            this.productItems = response.data;
                            this.initAddonDepartureDates();
                            this.$nextTick(() => {
                                if(this.isHasRoom) {
                                    this.productItems.product.forEach(item => {
                                        item.book_request = 1;
                                        this.updateModelValue(1, item);
                                    });
                                }
                                if(Array.isArray(this.productItems.product)) {
                                    const initQtyRaw = this.initialQty || (typeof window !== 'undefined' ? (new URLSearchParams(window.location.search).get('qty') || new URLSearchParams(window.location.search).get('pax') || sessionStorage.getItem('booking_initial_pax')) : null);
                                    const initialPax = parseInt(initQtyRaw, 10);

                                    this.productItems.product.forEach(item => {
                                        if(item.book_request > 0) {
                                            this.updateModelValue(item.book_request, item);
                                        } else if(!this.confirmId && !this.switchOrderId && initialPax > 0) {
                                            if (this.isSeaterProduct(item) || (!this.isHasRoom && (item.guest === 'Adult' || item.field_name === 'adult'))) {
                                                item.book_request = initialPax.toString();
                                                this.updateModelValue(initialPax, item);
                                            }
                                        }
                                    });

                                    if (typeof window !== 'undefined') {
                                        try { sessionStorage.removeItem('booking_initial_pax'); } catch(e) {}
                                    }
                                }
                            });
                        } else {
                            this.productItems = {};
                        }
                    }).catch(error => {
                        this.productItems = {};
                        this.attributes.departure_date = null;
                        if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                            errorHelper.error(error);
                        }
                        this.errorMessage = errorHelper.errorMessage(error);
                    }).finally(() => {
                        if(!this.isStandalone && loaderId) {
                            elementHelper.loader.hide(loaderId);
                            loaderId = null;
                        }
                    });
                } else {
                    await this.$refs.googleRecaptcha.verify().then(async token => {
                        payload.token = token;
                        AjxService.post(endpoint, payload).then(response => {
                            if(!objectHelper.isEmptyObject(response.data)) {
                                if(response.data.hasOwnProperty('attributes')) {
                                    if(!objectHelper.isEmptyObject(response.data.attributes)) {
                                        Object.entries(response.data.attributes).forEach(([key, value]) => {
                                            if(!['ccs_support_option', 'ccs_country_name', 'ccs_city_name', 'billing_country_name', 'billing_state_name', 'billing_city_name'].includes(key)) {
                                                if(key==='billing_city') {
                                                    this.attributes['billingCityOptions'] = [
                                                        {
                                                            id: value,
                                                            name: response.data.attributes.billing_city_name || '',
                                                            state_id: response.data.attributes.billing_state || null,
                                                            country_id: response.data.attributes.billing_country || null
                                                        }
                                                    ];
                                                } else if(key==='billing_state') {
                                                    this.attributes['billingStateOptions'] = [
                                                        {
                                                            id: value,
                                                            name: response.data.attributes.billing_state_name || '',
                                                            country_id: response.data.attributes.billing_country || null
                                                        }
                                                    ];
                                                } else if(key==='billing_country') {
                                                    this.attributes['billingCountryOptions'] = [
                                                        {
                                                            id: value,
                                                            name: response.data.attributes.billing_country_name || ''
                                                        }
                                                    ];
                                                }
                                                this.attributes[key] = value;
                                            }
                                        })
                                    }
                                    delete response.data.attributes;
                                }

                                this.productItems = response.data;
                                this.initAddonDepartureDates();
                                this.$nextTick(() => {
                                    if(this.isHasRoom) {
                                        if(this.isHasRoom) {
                                            const hasBookRequest = this.productItems.product.some(item => item.hasOwnProperty('book_request'));
                                            if (!hasBookRequest) {
                                                this.productItems.product.forEach(item => {
                                                    item.book_request = 1;
                                                    this.updateModelValue(1, item);
                                                });
                                            }
                                        }
                                    }
                                    if(Array.isArray(this.productItems.product)) {
                                        const initQtyRaw = this.initialQty || (typeof window !== 'undefined' ? (new URLSearchParams(window.location.search).get('qty') || new URLSearchParams(window.location.search).get('pax') || sessionStorage.getItem('booking_initial_pax')) : null);
                                        const initialPax = parseInt(initQtyRaw, 10);

                                        this.productItems.product.forEach(item => {
                                            if(item.book_request > 0) {
                                                this.updateModelValue(item.book_request, item);
                                            } else if(!this.confirmId && !this.switchOrderId && initialPax > 0) {
                                                if (this.isSeaterProduct(item) || (!this.isHasRoom && (item.guest === 'Adult' || item.field_name === 'adult'))) {
                                                    item.book_request = initialPax.toString();
                                                    this.updateModelValue(initialPax, item);
                                                }
                                            }
                                        });

                                        if (typeof window !== 'undefined') {
                                            try { sessionStorage.removeItem('booking_initial_pax'); } catch(e) {}
                                        }
                                    }
                                });
                            } else {
                                this.productItems = {};
                            }
                        }).catch(error => {
                            this.productItems = {};
                            this.attributes.departure_date = null;
                            if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                                errorHelper.error(error);
                            }
                            this.isMissingRequest = true;
                        });
                    });
                }
            }
        },
        isGrouping(item) {
            return (item.hasOwnProperty('guest') && item.guest && !['adult', 'child', 'infant', 'tour_leader'].includes(item.field_name));
        },
        isSeaterProduct(item = null) {
            if (item && typeof item === 'object') {
                return !!(item.field_name === 'seater' || item.is_seater);
            }
            return !!(this.productItems?.is_seater);
        },
        getLabelPriceType(item) {
            if (this.isSeaterProduct(item)) {
                const qty = parseInt(item.book_request) || 0;
                return qty > 1 ? 'Guests' : 'Guest';
            }
            if(this.isGrouping(item)) {
                return item.guest;
            }
            return item.name;
        },
        getNotePriceType(item, property) {
            let _note = (item[property] || '').trim();
            if(this.isGrouping(item)) {
                if(item.hasOwnProperty('guest')) {
                    if(item.guest.toLowerCase() === 'adult') {
                        _note = item[`adult_${property}`] || (item[`guest_${property}`] || '');
                    } else if(item.guest.toLowerCase() === 'child') {
                        _note = item[`child_${property}`] || (item[`guest_${property}`] || '');
                    } else if(item.guest.toLowerCase() === 'infant') {
                        _note = item[`infant_${property}`] || (item[`guest_${property}`] || '');
                    }
                }
            }
            return _note;
        },
        getPrice(item, subPriceInfo = 'pax')  {
            if (this.isSeaterProduct(item)) {
                const qty = parseInt(item.book_request) || 0;
                if (qty <= 0) {
                    return `<span class="text-muted fst-italic" style="font-size: 13.5px;">Select guests</span>`;
                }

                const tiers = item.seater_tiers || this.productItems?.seater_tiers || [];
                const matchedTier = tiers.find(t => qty >= t.min_qty && qty <= t.max_qty) || tiers[0];
                const tierPrice = matchedTier ? (parseFloat(matchedTier.price) || 0) : (parseFloat(item.price) || 0);

                const curr = this.productItems.currency ? this.productItems.currency.trim() : 'A$';
                const formatValue = formatHelper.formatNumber(tierPrice, (curr.toLowerCase() === 'rp' ? 'id-ID' : 'en-US'));
                return `<strong class="fst-normal">${curr + formatValue}</strong>`;
            }

            let formatValue;
            const price = (typeof (item.price || 0)) === 'number' ? (item.price || 0) : (!isNaN(parseFloat(item.price)) ? parseFloat(item.price) : 0);
            const priceInfo = this.getQuantity(item, true) >= 2 ? `<sub>/${subPriceInfo}</sub>` : '';

            formatValue = formatHelper.formatNumber(price, (this.productItems.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
            if(formatValue) {
                if(price===0) {
                    return ``;
                }
                return `<strong class="fst-normal">${price===0 ? '' : this.productItems.currency + formatValue}</strong>${priceInfo}`;
            }
        },
        getQuantity(item, isNumberOutput=false) {
            let _quantity = isNaN(parseInt(item.quantity) || 0) ? 0 : (parseInt(item.quantity) || 0);
            if (this.isGrouping(item)) {
                if(item.hasOwnProperty('guest')) {
                    _quantity = isNaN(parseInt(item[`${item.guest.toLowerCase()}_qty`]) || 0) ? 0 : (parseInt(item[`${item.guest.toLowerCase()}_qty`]) || 0);
                }
            }

            if(!isNaN(_quantity) && _quantity > 0) {
                return isNumberOutput ? _quantity : (_quantity>1 ? `${_quantity} ` : '');
            }
            return isNumberOutput ? 0 : '';
        },
        showInputQtyType(item) {
            if (this.isSeaterProduct(item)) {
                if (!item.bkrqOptions || item.bkrqOptions.length === 0) {
                    const min = item.seater_min_qty || this.productItems?.seater_min_qty || 1;
                    const max = item.seater_max_qty || this.productItems?.seater_max_qty || 10;
                    const options = [];
                    for (let i = min; i <= max; i++) {
                        options.push({
                            id: i.toString(),
                            name: i.toString()
                        });
                    }
                    item.bkrqOptions = options;
                }
                return 'selectInput';
            }

            const bookMin = isNaN(parseInt(item.book_min) || 0) ? 0 : (parseInt(item.book_min) || 0);
            const bookMax = isNaN(parseInt(item.book_max) || 0) ? 0 : (parseInt(item.book_max) || 0);
            const quantity = this.getQuantity(item, true);
            let _options = [];

            if(bookMin > 0 || bookMax > 0 || quantity) {
                item.bkrqOptions = [];
                if(bookMin > 0 && bookMax > 0) {
                    if(bookMin <= bookMax) {
                        if(quantity >= bookMax && quantity <= bookMin) {
                            _options = [];
                            for (let i = quantity; i <= bookMax; i++) {
                                _options.push({
                                    id: i.toString(),
                                    name: i.toString()
                                })
                            }
                            item.bkrqOptions = _options;
                        } else if (quantity > 0) {
                            item.bkrqOptions = [
                                {
                                    id: quantity.toString(),
                                    name: quantity.toString()
                                }
                            ];
                        } else {
                            _options = [];
                            for (let i = bookMin; i <= bookMax; i++) {
                                _options.push({
                                    id: i.toString(),
                                    name: i.toString()
                                })
                            }
                            item.bkrqOptions = _options;
                        }
                    } else if (quantity > 0) {
                        item.bkrqOptions = [
                            {
                                id: quantity.toString(),
                                name: quantity.toString()
                            }
                        ];
                    }
                }  else if(bookMax > 0) {
                    _options = [];
                    if (quantity > 0 && quantity <= bookMax) {
                        for (let i = quantity; i <= bookMax; i++) {
                            _options.push({
                                id: i.toString(),
                                name: i.toString()
                            });
                        }
                    } else if (quantity > 0 && quantity > bookMax) {
                        _options.push({
                            id: quantity.toString(),
                            name: quantity.toString()
                        });
                    } else {
                        for (let i = 1; i <= bookMax; i++) {
                            _options.push({
                                id: i.toString(),
                                name: i.toString()
                            });
                        }
                    }
                    item.bkrqOptions = _options;
                } else if(bookMin > 0) {
                    _options = [];
                    if (quantity >= bookMax) {
                        _options.push({
                            id: quantity.toString(),
                            name: quantity.toString()
                        });
                    } else {
                        _options.push({
                            id: bookMin.toString(),
                            name: bookMin.toString()
                        });
                    }
                    item.bkrqOptions = _options;
                } else if (quantity > 0) {
                    item.bkrqOptions = [
                        {
                            id: quantity.toString(),
                            name: quantity.toString()
                        }
                    ];
                }
                return 'selectInput'
            }
            return 'numberInput'
        },
        updateModelValue(value, item) {
            if (this.isSeaterProduct(item)) {
                const qty = isNaN(parseInt(value) || 0) ? 0 : (parseInt(value) || 0);
                const tiers = item.seater_tiers || this.productItems?.seater_tiers || [];
                const matchedTier = tiers.find(t => qty >= t.min_qty && qty <= t.max_qty);
                if (matchedTier) {
                    const oldId = item.id;
                    item.price = matchedTier.price;
                    item.group_id = matchedTier.group_id;
                    item.name = matchedTier.name;
                    item.id = matchedTier.id;
                    this.attributes.price_type = matchedTier.group_id;

                    if (oldId !== matchedTier.id && this.productItems?.manifest) {
                        if (this.productItems.manifest[oldId] && !this.productItems.manifest[matchedTier.id]) {
                            this.productItems.manifest[matchedTier.id] = this.productItems.manifest[oldId];
                            delete this.productItems.manifest[oldId];
                        }
                    }
                }
            }

            if(this.productItems.manifest && this.productItems.manifest.hasOwnProperty(item.id)) {
                let _guests = [];
                let _listGuest = [];
                const total = isNaN(parseInt(value) || 0)? 0 : (parseInt(value) || 0);
                if(total<=0) {
                    this.productItems.manifest[item.id].guests = [];
                } else if (total > this.productItems.manifest[item.id].guests.length) {
                    if(this.isHasRoom) {
                        _listGuest = [...this.productItems.manifest[item.id].guests];
                        for (let i = _listGuest.length; i < total; i++) {
                            let _quantity = this.getQuantity(item, true);
                            _quantity = _quantity===0? 1 : _quantity;
                            _guests = [];
                            for (let j = 0; j < _quantity; j++) {
                                _guests.push({
                                    ...this.productItems.manifest[item.id].attributes,
                                    id: utilHelper.getUuid4()
                                });
                            }
                            _listGuest.push(_guests);
                        }
                        this.productItems.manifest[item.id].guests = _listGuest;
                        this.autoFillFirstManifest();
                    } else {
                        _guests = [...this.productItems.manifest[item.id].guests];
                        for (let i = this.productItems.manifest[item.id].guests.length; i < total; i++) {
                            _guests.push({
                                ...this.productItems.manifest[item.id].attributes,
                                id: utilHelper.getUuid4()
                            });
                        }
                        this.productItems.manifest[item.id].guests = _guests;
                        this.autoFillFirstManifest();
                    }
                } else if (total < this.productItems.manifest[item.id].guests.length) {
                    if(this.isHasRoom) {
                        _listGuest = [...this.productItems.manifest[item.id].guests];
                        for (let i = total; i < _listGuest.length; i++) {
                            _listGuest.pop();
                        }
                        this.productItems.manifest[item.id].guests = _listGuest;
                    } else {
                        _guests = [...this.productItems.manifest[item.id].guests];
                        for (let i = total; i < this.productItems.manifest[item.id].guests.length; i++) {
                            _guests.pop();
                        }
                        this.productItems.manifest[item.id].guests = _guests;
                    }

                }
            }
        },
        calculateQty(item, isAddons = false) {
            if(this.isHasRoom && !isAddons) {
                const price = (typeof (item.price || 0)) === 'number' ? (item.price || 0) : (!isNaN(parseFloat(item.price)) ? parseFloat(item.price) : 0);
                if(this.getLabelPriceType(item).toLowerCase() === 'infant' && price <= 0) {
                    let total = 0;
                    const isRequired = (items) => {
                        for (let i = 0; i < items.length; i++) {
                            if(items[i].hasOwnProperty('children') && items[i].children.length > 0) {
                                const _required = isRequired(items[i].children);
                                if(_required) {
                                    return true;
                                }
                            } else if(items[i].hasOwnProperty('props')) {
                                const _required = items[i].props.required || false;
                                if(_required) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }

                    if(this.productItems.manifest && this.productItems.manifest[item.id] && !isRequired(this.productItems.manifest[item.id].customForm)) {
                        this.productItems.manifest[item.id].guests.forEach(guests => {
                            guests.forEach(guest => {
                                if(guest.name && guest.name.trim() || guest.birthdate && guest.birthdate.trim()) {
                                    total ++;
                                }
                            });
                        });
                    }

                    return total;
                } else {
                    const qty = this.getQuantity(item, true);
                    return (qty===0 ? 1 : qty) * item.book_request;
                }
            }
            return item.book_request;
        },
        calculatePax(item, numberOutput = false, defaultQty = 0, isAddons = false) {
            if (this.isSeaterProduct(item) && !isAddons) {
                const qty = parseInt(item.book_request) || 0;
                if (qty <= 0) {
                    return numberOutput ? 0 : '-';
                }
                const tiers = item.seater_tiers || this.productItems?.seater_tiers || [];
                const matchedTier = tiers.find(t => qty >= t.min_qty && qty <= t.max_qty) || tiers[0];
                const tierPrice = matchedTier ? (parseFloat(matchedTier.price) || 0) : (parseFloat(item.price) || 0);
                if (tierPrice) {
                    return numberOutput ? tierPrice : this.productItems.currency + formatHelper.formatNumber(tierPrice, (this.productItems.currency.trim().toLowerCase() === 'rp' ? 'id-ID' : 'en-US'));
                }
                return numberOutput ? 0 : '-';
            }

            const c_qty = this.calculateQty(item, isAddons);
            const qty = typeof c_qty === 'number' ? (isNaN(c_qty) ? 0: c_qty) : (isNaN(parseInt(c_qty)) ? 0 : parseInt(c_qty));
            const price = (typeof (item.price || 0)) === 'number' ? (item.price || 0) : (!isNaN(parseFloat(item.price)) ? parseFloat(item.price) : 0);
            if(price) {
                const total = (qty===0 ? defaultQty : qty) * price;
                if(total) {
                    return numberOutput ? total : this.productItems.currency + formatHelper.formatNumber(total, (this.productItems.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US'));
                }
            }
            return numberOutput ? 0 : '-';
        },
        calculateSubtotal(numberOutput = false) {
            let total = 0;
            this.productItems.product.forEach(item => {
                if(item.book_request>0) {
                    total += this.calculatePax(item, true);
                }
            });

            if(Array.isArray(this.productItems.pickup) && this.productItems.pickup.length>0) {
                const match = this.productItems.pickup.find(item => item.checked);
                if(match) {
                    if(this.isPointToPointTicket || this.isReturnDifferentDPTP) {
                        total += this.calculatePax(match, true, 1) * 2;
                    } else {
                        total += this.calculatePax(match, true, 1);
                    }
                }
            }

            if(Array.isArray(this.productItems.dropOff) && this.productItems.dropOff.length>0) {
                const match = this.productItems.dropOff.find(item => item.checked);
                if(match) {
                    total += this.calculatePax(match, true, 1);
                }
            }

            if(this.addonFilterSelections.length>0) {
                this.addonFilterSelections.forEach(item => {
                    if(item.hasOwnProperty('_labelGroup')) {
                        item.items.forEach(child => {
                            total += this.calculatePax(child, true, 0, true);
                        })
                    } else {
                        total += this.calculatePax(item, true, 0, true);
                    }
                });
            }

            return numberOutput ? total : (total>0? this.productItems.currency + formatHelper.formatNumber(total, (this.productItems.currency.trim().toLowerCase()==='rp'?'id-ID':'en-US')) : '-');
        },
        addRoom() {
            this.productItems.product.forEach(item => {
                item.book_request ++;
                this.updateModelValue(item.book_request, item);
            });
        },
        removeRoom() {
            this.productItems.product.forEach(item => {
                item.book_request --;
                this.updateModelValue(item.book_request, item);
            });
        },
        locationServiceInfo(item) {
            const _time = (item.time || '') ? `<span class="clock">${item.time}</span>` : '';
            const _mapLatLong = (item.latitude || '') && (item.longitude || '') ? `<span class="meet-point"><a href="https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}" target="_blank">Meeting Point (click)</a></span>` : '';
            const _meetPoint = (item.url_map || '') ? `<span class="meet-point"><a href="${item.url_map}" target="_blank">Meeting Point (click)</a></span>` : (_mapLatLong);

            if(_time || _meetPoint) {
                return `
                        ${_time}
                        ${_meetPoint}
                    `;
            }

            return '';
        },
        locationIsSelected(items, outputBool = true) {
            if(Array.isArray(items) && items.length>0) {
                const match = items.find(item => item.checked);
                if(outputBool) {
                    return !!match;
                }
                return match;
            }
            return outputBool ? false : null;
        },
        removeLocationSelected(items) {
            const match = items.find(item => item.checked);
            if(match) {
                match.checked = null;
            }
        },
        updateLocationSelected(item, items) {
            items.forEach(item_ => {
                if(item_.id !== item.id)
                {
                    item_.checked = null;
                }
            })
        },
        addonServiceInfo(item) {
            const _quantity = this.getQuantity(item) ? `<span class="qty">${this.getQuantity(item)}(Qty.)</span>` : '';
            const _time = (item.hour_start || item.hour_last) ? `<span class="clock">${(item.hour_start || '') + ((item.hour_start || '') && (item.hour_last || '')?'-':'') + (item.hour_last || '')}</span>` : '';
            const _meetPoint = (item.latitude || '') && (item.longitude || '') ? `<span class="meet-point"><a href="https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}" target="_blank">Meeting Point (click)</a></span>` : '';
            const _duration = (!isNaN(parseInt(item.duration || '')) &&  parseInt(item.duration || '') > 0) ? `<span class="duration">${item.duration} ${item.duration_type + ((item.duration_type!=='v.v (oneway)' && parseInt(item.duration || '')>1)? 's' : '')} (Duration)</span>` : '';

            if(_quantity || _meetPoint || _duration || _time) {
                return `
                        ${_quantity}
                        ${_duration}
                        ${_time}
                        ${_meetPoint}
                    `;
            }

            return '';
        },
        isRequireDepartureDate(item) {
            if (!item) return false;
            const depVal = item.required_departure_date;
            return depVal === 'required_departure_date' ||
                   depVal === '1' ||
                   depVal === 1 ||
                   depVal === true ||
                   depVal === 'true';
        },
        isGroupRequireDepartureDate(items) {
            if (!Array.isArray(items) || items.length === 0) return false;
            return items.some(item => this.isRequireDepartureDate(item));
        },
        isAddonGroupSelected(items) {
            if (!Array.isArray(items)) return false;
            return items.some(item => {
                const qty = parseInt(this.calculateQty(item, true) || item.book_request || 0);
                return !isNaN(qty) && qty > 0;
            });
        },
        isAddonItemSelected(item) {
            if (!item) return false;
            const qty = parseInt(this.calculateQty(item, true) || item.book_request || 0);
            return !isNaN(qty) && qty > 0;
        },
        onAddonGroupDepartureDateChange(date, items) {
            if (Array.isArray(items)) {
                items.forEach(item => {
                    item.departure_date = date;
                });
            }
        },
        onAddonGroupQtyChange(val, item, items) {
            item.book_request = val;
            this.$nextTick(() => {
                const isSelected = this.isAddonGroupSelected(items);
                if (isSelected) {
                    const defaultDate = this.attributes.departure_date || (this.addonDepartureDateOptions[0]?.id || null);
                    if (!items[0].departure_date) {
                        this.onAddonGroupDepartureDateChange(defaultDate, items);
                    }
                } else {
                    this.onAddonGroupDepartureDateChange(null, items);
                }
            });
        },
        onAddonSingleQtyChange(val, item) {
            item.book_request = val;
            this.$nextTick(() => {
                const isSelected = this.isAddonItemSelected(item);
                if (isSelected) {
                    const defaultDate = this.attributes.departure_date || (this.addonDepartureDateOptions[0]?.id || null);
                    if (!item.departure_date) {
                        item.departure_date = defaultDate;
                    }
                } else {
                    item.departure_date = null;
                }
            });
        },
        formatAddonDate(strDate) {
            if (!strDate) return '';
            return dateHelper.dateParse(strDate).format('DD MMM YYYY');
        },
        resetAddonDepartureDates() {
            this.initAddonDepartureDates();
        },
        initAddonDepartureDates() {
            if(this.productItems && Array.isArray(this.productItems.addons)) {
                const validDateIds = this.addonDepartureDateOptions.map(opt => opt.id);
                const defaultDate = this.attributes.departure_date || (validDateIds[0] || null);

                this.productItems.addons.forEach(addon => {
                    (addon.list || []).forEach(list => {
                        (list.data || []).forEach(items => {
                            if(Array.isArray(items)) {
                                if (list.addon_key === 'Guests') {
                                    const isSelected = this.isAddonGroupSelected(items);
                                    if (isSelected) {
                                        let currentDep = items.find(it => it.departure_date)?.departure_date;
                                        if (!currentDep || !validDateIds.includes(currentDep)) {
                                            currentDep = defaultDate;
                                        }
                                        items.forEach(item => {
                                            item.departure_date = currentDep;
                                        });
                                    } else {
                                        items.forEach(item => {
                                            item.departure_date = null;
                                        });
                                    }
                                } else {
                                    items.forEach(item => {
                                        const isSelected = this.isAddonItemSelected(item);
                                        if (isSelected) {
                                            if (!item.departure_date || !validDateIds.includes(item.departure_date)) {
                                                item.departure_date = defaultDate;
                                            }
                                        } else {
                                            item.departure_date = null;
                                        }
                                    });
                                }
                            }
                        });
                    });
                });
            }
        },
        async continueOrder(event) {
            const form = event.target.closest('form');
            const existingAlerts = form.querySelectorAll('#alert-pickup-required, #alert-dropoff-required');
            const scrollToInvalid = (form) => {
                const invalidRadios = form.querySelectorAll('input[type="radio"].is-invalid, input[type="radio"][required]:not(:checked)');
                let hasRadioAlerts = false;
                console.log(invalidRadios);
                if (invalidRadios.length > 0) {
                    // Check for pickup accordion errors
                    const pickupRadios = Array.from(invalidRadios).filter(radio => radio.closest('.accordion.pickup'));
                    if (pickupRadios.length > 0) {
                        const accordionPickup = pickupRadios[0].closest('.accordion.pickup');
                        const alertId = 'alert-pickup-required';

                        // Remove existing alert if present
                        const existingAlert = accordionPickup.querySelector(`#${alertId}`);
                        if (existingAlert) {
                            existingAlert.remove();
                        }

                        // Create new alert
                        const alertDiv = document.createElement('div');
                        alertDiv.id = alertId;
                        alertDiv.className = 'alert alert-danger alert-dismissible fade show mb-2';
                        alertDiv.innerHTML = `<i class="ti ti-alert-circle me-1"></i> Please select a pickup location.`;

                        // Insert alert at the top of accordion
                        accordionPickup.insertBefore(alertDiv, accordionPickup.firstChild);
                        hasRadioAlerts = true;
                    }

                    // Check for dropoff accordion errors
                    const dropoffRadios = Array.from(invalidRadios).filter(radio => radio.closest('.accordion.dropoff'));
                    if (dropoffRadios.length > 0) {
                        const accordionDropoff = dropoffRadios[0].closest('.accordion.dropoff');
                        const alertId = 'alert-dropoff-required';

                        // Remove existing alert if present
                        const existingAlert = accordionDropoff.querySelector(`#${alertId}`);
                        if (existingAlert) {
                            existingAlert.remove();
                        }

                        // Create new alert
                        const alertDiv = document.createElement('div');
                        alertDiv.id = alertId;
                        alertDiv.className = 'alert alert-danger alert-dismissible fade show mb-2';
                        alertDiv.innerHTML = `<i class="ti ti-alert-circle me-1"></i> Please select a drop off location.`;

                        // Insert alert at the top of accordion
                        accordionDropoff.insertBefore(alertDiv, accordionDropoff.firstChild);
                        hasRadioAlerts = true;
                    }
                }

                // Scroll to first invalid input when validation fails
                const checkSecond = form.querySelector('.card-body-ckscnd').querySelector('input:invalid, select:invalid, textarea:invalid, .is-invalid');
                const firstInvalidElement = form.querySelector('input:invalid, select:invalid, textarea:invalid, .is-invalid');
                const firstAlert = form.querySelector('#alert-pickup-required, #alert-dropoff-required');

                // Prioritize showing first invalid element over radio alerts
                if ((firstInvalidElement || checkSecond) && (!hasRadioAlerts || firstInvalidElement.getBoundingClientRect().top < (firstAlert?.getBoundingClientRect().top || Infinity))) {
                    // const elementPosition = firstInvalidElement.getBoundingClientRect().top;
                    const elementPosition = (checkSecond ? checkSecond :  firstInvalidElement).getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - (this.isStandalone ? 100 : 20);

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });

                    // Focus on the element if it's focusable
                    if(firstInvalidElement.focus) {
                        firstInvalidElement.focus();
                    }
                } else if (checkSecond || firstAlert) {
                    // Only scroll to alert if no other invalid elements are above it
                    const elementPosition = (checkSecond ? checkSecond : firstAlert).getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - (this.isStandalone ? 100 : 20);

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }

            formHelper.reset(form);
            existingAlerts.forEach(alert => alert.remove());

            // Validate required departure date for selected addons
            for (const addon of this.addonFilterSelections) {
                if (addon.hasOwnProperty('_labelGroup')) {
                    if (this.isGroupRequireDepartureDate(addon.items) && !addon.departure_date) {
                        sweetAlertHelper.alert('Validation Error', `Please select a departure date for "${addon._labelGroup}".`, 'error');
                        return;
                    }
                } else {
                    if (this.isRequireDepartureDate(addon) && !addon.departure_date) {
                        sweetAlertHelper.alert('Validation Error', `Please select a departure date for "${addon.name || this.getLabelPriceType(addon)}".`, 'error');
                        return;
                    }
                }
            }

            if(formHelper.validated(form, form=>{
                scrollToInvalid(form);
            })) {
                if (this.isSeaterProduct() && Array.isArray(this.productItems?.product) && this.productItems.product.length > 0) {
                    const seaterItem = this.productItems.product[0];
                    const qty = parseInt(seaterItem.book_request) || 0;
                    const tiers = seaterItem.seater_tiers || this.productItems?.seater_tiers || [];
                    const matchedTier = tiers.find(t => qty >= t.min_qty && qty <= t.max_qty);
                    if (matchedTier) {
                        const oldId = seaterItem.id;
                        this.attributes.price_type = matchedTier.group_id;
                        seaterItem.id = matchedTier.id;
                        seaterItem.group_id = matchedTier.group_id;
                        seaterItem.price = matchedTier.price;
                        seaterItem.name = matchedTier.name;
                        if (oldId !== matchedTier.id && this.productItems?.manifest) {
                            if (this.productItems.manifest[oldId] && !this.productItems.manifest[matchedTier.id]) {
                                this.productItems.manifest[matchedTier.id] = this.productItems.manifest[oldId];
                                delete this.productItems.manifest[oldId];
                            }
                        }
                    }
                }

                const strDate = dateHelper.dateParse(this.attributes.departure_date).format('YYYYMMDD');
                const endpoint = `/booking/${this.attributes.productId}/${this.attributes.price_type}/${strDate}/continue` + (this.confirmId?`/${this.confirmId}` : ``);
                const loaderId = utilHelper.getUniqueId();
                const payload = {
                    ...this.attributes,
                    items: this.getBookingItems()
                };
                let element = null;

                if(!this.isStandalone) {
                    element = this.$el.closest('.modal-content');
                    element.classList.add('position-relative');
                    payload.staff = true;
                }

                delete payload.departure_date;
                delete payload.price_type;
                delete payload.productId;
                delete payload.phoneOptions;
                delete payload.op_phoneOptions;
                delete payload.billingCityOptions;
                delete payload.billingStateOptions;
                delete payload.billingCountryOptions;

                if(this.switchOrderId) {
                    payload.switchOrderId = this.switchOrderId;
                }

                elementHelper.loader.show(loaderId, element, 36, 36, 'dots');
                if (this.loggedIn) {
                    ApiService.post(endpoint, payload).then(response => {
                        if(!objectHelper.isEmptyObject(response.data)) {
                            if(response.data.hasOwnProperty('confirmId')) {
                                if (response.data.isPriceChanged) {
                                    formHelper.reset(form);
                                    this.$emit('viewBooking', {
                                        confirmId: response.data.confirmId,
                                        departureDate: this.attributes.departure_date,
                                        profile: {
                                            id: this.attributes.profile_id,
                                            name: this.attributes.req_name,
                                            email: this.attributes.req_email
                                        }
                                    });
                                    sweetAlertHelper.alert('Price Change Detected', 'We’ve notified the agency of the price change. Please confirm it in the guest’s notification section on the review page.', 'info');
                                } else {
                                    if (this.isStandalone) {
                                        window.location.href = `/booking/review/${response.data.confirmId}`;
                                    } else {
                                        formHelper.reset(form);
                                        this.$emit('viewBooking', {
                                            confirmId: response.data.confirmId,
                                            departureDate: this.attributes.departure_date,
                                            profile: {
                                                id: this.attributes.profile_id,
                                                name: this.attributes.req_name,
                                                email: this.attributes.req_email
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }).catch(error => {
                        if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                            errorHelper.error(error);
                        }

                        if(error?.response?.status===409) {
                            if(this.isStandalone) {
                                if(this.confirmId) {
                                    window.location.href = window.location.pathname.replace(/\/[^\/]*\/[^\/]*$/, `/${strDate}/${this.confirmId}`) + window.location.search + window.location.hash;
                                } else {
                                    window.location.href = window.location.pathname.replace(/\/[^\/]*$/, `/${strDate}`) + window.location.search + window.location.hash;
                                }
                            } else {
                                sweetAlertHelper.alert('Error Booking', errorHelper.errorMessage(error), 'error');
                            }
                        } else if(error?.response?.status===422) {
                            const nestedErrors = {};
                            const errors = errorHelper.error(error);
                            formHelper.markInvalid(form, errors, true, ['.product-item', '.travel-manifest', '.product-addons']);
                            Object.keys(errors).forEach(key => {
                                if (key.includes('.')) {
                                    const [parentKey, childKey] = key.split('.');
                                    if (!nestedErrors[parentKey]) {
                                        nestedErrors[parentKey] = {};
                                    }
                                    nestedErrors[parentKey][childKey] = errors[key];
                                }
                            });

                            if(!objectHelper.isEmptyObject(nestedErrors)) {
                                Object.entries(nestedErrors).forEach(([parentKey, _errors]) => {
                                    const element = form.querySelector(`.accordion-collapse[data-manifest-id="${parentKey}"]`);
                                    if(element) {
                                        element.querySelectorAll('.is-invalid').forEach(input => {
                                            input.classList.remove('is-invalid');
                                        });
                                        formHelper.markInvalid(element, _errors, false, ['.travel-manifest']);
                                    }
                                });
                            }

                            scrollToInvalid(form);
                        }
                    }).finally(() => {
                        elementHelper.loader.hide(loaderId);
                        if(element) {
                            element.classList.remove('position-relative');
                        }
                    });
                } else {
                    await this.$refs.googleRecaptcha.verify().then(async token => {
                        payload.token = token;
                        AjxService.post(endpoint, payload).then(response => {
                            if(!objectHelper.isEmptyObject(response.data)) {
                                if(response.data.hasOwnProperty('confirmId')) {
                                    if (response.data.isPriceChanged) {
                                        sweetAlertHelper.alert('Price Change Detected', 'The agency has been notified of the price change. Please confirm it in the notification section on the review page.', 'info').then(() => {
                                            if (this.isStandalone) {
                                                window.location.href = `/booking/review/${response.data.confirmId}`;
                                            } else {
                                                formHelper.reset(form);
                                                this.$emit('viewBooking', {
                                                    confirmId: response.data.confirmId,
                                                    departureDate: this.attributes.departure_date,
                                                    profile: {
                                                        id: this.attributes.profile_id,
                                                        name: this.attributes.req_name,
                                                        email: this.attributes.req_email
                                                    }
                                                });
                                            }
                                        });
                                    } else {
                                        if (this.isStandalone) {
                                            window.location.href = `/booking/review/${response.data.confirmId}`;
                                        } else {
                                            formHelper.reset(form);
                                            this.$emit('viewBooking', {
                                                confirmId: response.data.confirmId,
                                                departureDate: this.attributes.departure_date,
                                                profile: {
                                                    id: this.attributes.profile_id,
                                                    name: this.attributes.req_name,
                                                    email: this.attributes.req_email
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        }).catch(error => {
                            if (!error.response?.isCancel && (!error.name === 'AbortError' || !error.name === 'CanceledError') && (!error.message?.includes('aborted') || !error.message?.includes('canceled'))) {
                                errorHelper.error(error);
                            }

                            if(error?.response?.status===409) {
                                if(this.confirmId) {
                                    window.location.href = window.location.pathname.replace(/\/[^\/]*\/[^\/]*$/, `/${strDate}/${this.confirmId}`) + window.location.search + window.location.hash;
                                } else {
                                    window.location.href = window.location.pathname.replace(/\/[^\/]*$/, `/${strDate}`) + window.location.search + window.location.hash;
                                }
                            } else if(error?.response?.status===422) {
                                const nestedErrors = {};
                                const errors = errorHelper.error(error);
                                formHelper.markInvalid(form, errors, true, ['.product-item', '.travel-manifest', '.product-addons']);
                                Object.keys(errors).forEach(key => {
                                    if (key.includes('.')) {
                                        const [parentKey, childKey] = key.split('.');
                                        if (!nestedErrors[parentKey]) {
                                            nestedErrors[parentKey] = {};
                                        }
                                        nestedErrors[parentKey][childKey] = errors[key];
                                    }
                                });

                                if(!objectHelper.isEmptyObject(nestedErrors)) {
                                    Object.entries(nestedErrors).forEach(([parentKey, _errors]) => {
                                        const element = form.querySelector(`.accordion-collapse[data-manifest-id="${parentKey}"]`);
                                        if(element) {
                                            element.querySelectorAll('.is-invalid').forEach(input => {
                                                input.classList.remove('is-invalid');
                                            });
                                            formHelper.markInvalid(element, _errors, false, ['.travel-manifest']);
                                        }
                                    });
                                }

                                scrollToInvalid(form);
                            }
                        }).finally(() => {
                            elementHelper.loader.hide(loaderId);
                            if(element) {
                                element.classList.remove('position-relative');
                            }
                        });
                    }).catch(error => {
                        window.location.reload();
                    });
                }
            }
        },
        getBookingItems() {
            let bookingItems = {};
            let _items = [];
            let _manifest = [];
            if(!objectHelper.isEmptyObject(this.productItems)) {
                if(this.productItems.hasOwnProperty('product') && Array.isArray(this.productItems.product) && this.productItems.product.length > 0) {
                    let filteredItems = this.productItems.product.filter(item => item.book_request>0);
                    if(filteredItems.length) {
                        filteredItems.forEach(item => {
                            _manifest = [];
                            if(this.productItems.hasOwnProperty('manifest') && !objectHelper.isEmptyObject(this.productItems.manifest)) {
                                if(this.productItems.manifest && this.productItems.manifest.hasOwnProperty(item.id)) {
                                    if(this.productItems.manifest[item.id].hasOwnProperty('guests') && Array.isArray(this.productItems.manifest[item.id].guests) && this.productItems.manifest[item.id].guests.length>0) {
                                        _manifest = this.productItems.manifest[item.id].guests;
                                    }
                                }
                            }
                            _items.push({
                                id: item.id,
                                total: item.book_request,
                                manifest: _manifest
                            });
                        });
                        bookingItems.items = _items;
                    }
                }

                if(this.productItems.hasOwnProperty('pickup') && Array.isArray(this.productItems.pickup) && this.productItems.pickup.length > 0) {
                    const match = this.productItems.pickup.find(item => item.checked);
                    if(match) {
                        bookingItems.pickup = match.id;
                    }
                }

                if(this.productItems.hasOwnProperty('dropOff') && Array.isArray(this.productItems.dropOff) && this.productItems.dropOff.length > 0) {
                    const match = this.productItems.dropOff.find(item => item.checked);
                    if(match) {
                        bookingItems.dropOff = match.id;
                    }
                }

                if(this.addonFilterSelections.length > 0) {
                    _items = [];
                    this.addonFilterSelections.forEach(item => {
                        if (item.hasOwnProperty('_labelGroup')) {
                            item.items.forEach(_item => {
                                _items.push({
                                    id: _item.id,
                                    total: _item.book_request,
                                    departure_date: _item.departure_date || item.departure_date || null
                                });
                            });
                        } else {
                            _items.push({
                                id: item.id,
                                total: item.book_request,
                                departure_date: item.departure_date || null
                            });
                        }
                    });
                    bookingItems.addons = _items;
                }
            }
            return bookingItems;
        },
        getCustomForm(customData) {
            const newCustomData = cloneDeep(customData);
            cusfieldHelper.setCustomDataId(newCustomData);
            this.setCustomFormProps(newCustomData);
            return newCustomData;
        },
        setCustomFormProps(items) {
            if (Array.isArray(items) && items.length > 0) {
                items.forEach(item => {
                    if (item && item.props && item.props.name === 'birthdate') {
                        item.props.classCalendar = 'birthdate-date';
                    }
                    if (item && item.children && Array.isArray(item.children) && item.children.length > 0) {
                        this.setCustomFormProps(item.children);
                    }
                });
            }
        },
        profileClearOption() {
            this.attributes.name = null;
            this.attributes.email = null;
            this.attributes.nationality = null;
            this.attributes.phone = null;
            this.attributes.billing_address = null;
            this.attributes.billing_city = null;
            this.attributes.billing_state = null;
            this.attributes.billing_country = null;
            this.attributes.billing_zipcode = null;
            this.onCcsClearCountry();
        },
        profileSelectOption(event) {
            this.profileClearOption();
            this.attributes.billing_address = null;
            this.attributes.billing_city = null;
            this.attributes.billing_state = null;
            this.attributes.billing_country = null;
            this.attributes.billing_zipcode = null;
            this.onCcsClearCountry();
            this.attributes.name = event.data.name;
            this.attributes.email = event.data.email;
            this.attributes.nationality = event.data.nationality;
            if(event.data.phone1 && event.data.phone1prefix) {
                this.attributes.phone = [event.data.phone1prefix, event.data.phone1];
            } else if(event.data.phone2 && event.data.phone2prefix) {
                this.attributes.phone = [event.data.phone2prefix, event.data.phone2];
            }
            this.$nextTick(()=>{
                this.updateDepartureDate(this.attributes.departure_date);
            });
        },
        previewBooking() {
            if (this.productItems.confirm_id) {
                if(this.isStandalone) {
                    window.location.href = this.productItems.confirm_link;
                } else {
                    this.$emit('viewBooking', {
                        confirmId:this.productItems.confirm_id
                    });
                }
            }
        },
        shoppingCart() {
            if (this.productItems.scart_id) {
                if(this.isStandalone) {
                    window.location.href = this.productItems.scart_link;
                } else {
                    this.$emit('goShoppingCart', {shoppingCartId:this.productItems.scart_id});
                }
            }
        },
        onBillingAddressSelectCity(event) {
            this.attributes.billing_state = event.data.state_id;
            this.attributes.billing_country = event.data.country_id;
        },
        onBillingAddressSelectState(event) {
            if(!objectHelper.isEmptyObject(this.$refs.selectBillingCity.selectItem)) {
                if(this.$refs.selectBillingCity.selectItem.state_id !== event.data.id) {
                    this.attributes.billing_city = null;
                }
            }
            this.attributes.billing_country = event.data.country_id;
        },
        onBillingAddressSelectCountry(event) {
            if(!objectHelper.isEmptyObject(this.$refs.selectBillingCity.selectItem)) {
                if(this.$refs.selectBillingCity.selectItem.country_id !== event.data.id) {
                    this.attributes.billing_city = null;
                }
            }
            if(!objectHelper.isEmptyObject(this.$refs.selectBillingState.selectItem)) {
                if(this.$refs.selectBillingState.selectItem.country_id !== event.data.id) {
                    this.attributes.selectBillingState = null;
                }
            }
        },
        onBillingAddressClearOption() {
            this.attributes.billing_city = null;
            this.attributes.billing_state = null;
            this.attributes.billing_country = null;
        },
        autoFillFirstManifest() {
            if (this.productItems?.product?.length > 0 && this.productItems?.manifest) {
                const firstProduct = this.productItems.product[0];
                const manifest = (this.productItems.manifest && firstProduct) ? this.productItems.manifest[firstProduct.id] : null;
                if (manifest && Array.isArray(manifest.guests) && manifest.guests.length > 0) {
                    if (this.getLabelPriceType(firstProduct).toLowerCase() === 'adult') {
                        let guest;
                        if (this.isHasRoom) {
                            if (Array.isArray(manifest.guests[0]) && manifest.guests[0].length > 0) {
                                guest = manifest.guests[0][0];
                            }
                        } else {
                            guest = manifest.guests[0];
                        }

                        if (guest) {
                            if (this.isBookingForOther) {
                                guest.name = this.attributes.op_name;
                                guest.nationality = this.attributes.op_nationality;
                                if (Array.isArray(this.attributes.op_phone) && this.attributes.op_phone.length === 2) {
                                    const _phone = (this.attributes.op_phone[1] || '').replace(/\s+/g, '');
                                    guest.phone = _phone ? (_phone.startsWith('+') ? _phone : `+${_phone}`) : '';
                                } else {
                                    guest.phone = this.attributes.op_phone;
                                }
                            } else {
                                guest.name = this.attributes.name;
                                guest.nationality = this.attributes.nationality;
                                if (Array.isArray(this.attributes.phone) && this.attributes.phone.length === 2) {
                                    const _phone = (this.attributes.phone[1] || '').replace(/\s+/g, '');
                                    guest.phone = _phone ? (_phone.startsWith('+') ? _phone : `+${_phone}`) : '';
                                } else {
                                    guest.phone = this.attributes.phone;
                                }
                            }
                        }
                    }
                }
            }
        },
    }
}
</script>

<style>
.tooltip-wide .tooltip-inner {
    max-width: 450px !important;
}
.lh-1-2 {
    line-height: 1.2 !important;
}
</style>
